
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("go76J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $9wGTI = parcelRequire("9wGTI");


var $brERQ = parcelRequire("brERQ");


var $dYoxI = parcelRequire("dYoxI");


var $7Ndnw = parcelRequire("7Ndnw");


var $2mcHd = parcelRequire("2mcHd");


var $3b6WO = parcelRequire("3b6WO");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $ep3mz = parcelRequire("ep3mz");


var $dJsIz = parcelRequire("dJsIz");





var $ldKLB = parcelRequire("ldKLB");


var $kcIQr = parcelRequire("kcIQr");


var $6VdZc = parcelRequire("6VdZc");


var $1P7Cq = parcelRequire("1P7Cq");




const $28325260fc5afd05$var$DISABLED_STATE = {
    status: 'disabled',
    hasExtensions: false
};
const $28325260fc5afd05$var$NO_EXTENSIONS = {
    metadata: $28325260fc5afd05$var$DISABLED_STATE,
    actions: $28325260fc5afd05$var$DISABLED_STATE
};
const $28325260fc5afd05$var$LOAD_TIMEOUT = 60000;
const $28325260fc5afd05$var$getDiscoveryOutcome = (states)=>{
    if (states.some(({ status: status })=>status === 'failure')) return 'failure';
    if (states.some(({ status: status })=>status === 'access-unavailable')) return 'access-unavailable';
    return 'success';
};
const $28325260fc5afd05$var$getAction = (outcome)=>{
    if (outcome === 'success') return 'taskSuccess';
    if (outcome === 'failure') return 'taskFail';
    return 'taskAbort';
};
const $28325260fc5afd05$var$attachmentCountBucket = (count)=>{
    if (count === 0) return '0';
    if (count <= 10) return '1-10';
    if (count <= 100) return '11-100';
    return '101+';
};
const $28325260fc5afd05$export$7157f6971a221bee = ({ contentId: contentId, macroId: macroId, experienceName: experienceName, mode: mode, loading: loading, error: error, attachmentCount: attachmentCount })=>{
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const hydrating = (0, $1P7Cq.useIsSSROrHydrating)();
    const identity = `${mode}.${contentId}.${macroId}`;
    const identityRef = (0, $cozmU.useRef)(identity);
    identityRef.current = identity;
    const measurementRef = (0, $cozmU.useRef)();
    const extensionStateRef = (0, $cozmU.useRef)();
    const createEventRef = (0, $cozmU.useRef)(createEvent);
    createEventRef.current = createEvent;
    const finish = (0, $cozmU.useCallback)((measurement, outcome)=>{
        if (measurement.completed) return;
        measurement.completed = true;
        clearTimeout(measurement.timer);
        const endTime = performance.now();
        const states = measurement.extensions ? Object.values(measurement.extensions) : [];
        const discoverySucceeded = outcome === 'success' && states.length > 0 && states.every(({ status: status })=>status === 'disabled' || status === 'success');
        if (outcome === 'success') (0, $ldKLB.addCustomSpans)('attachments-macro/extensions-ready', measurement.startTime, endTime);
        createEventRef.current({
            type: 'sendOperationalEvent',
            data: {
                source: 'ui',
                actionSubject: 'macroTracker',
                action: $28325260fc5afd05$var$getAction(outcome),
                attributes: {
                    task: 'attachments-macro/load',
                    extensionKey: 'attachments',
                    outcome: outcome,
                    duration: endTime - measurement.startTime,
                    baseReadyDuration: measurement.baseReadyTime === undefined ? undefined : measurement.baseReadyTime - measurement.startTime,
                    extensionWaitDuration: measurement.baseReadyTime === undefined ? undefined : endTime - measurement.baseReadyTime,
                    hasApplicableExtensions: discoverySucceeded ? states.some(({ hasExtensions: hasExtensions })=>hasExtensions) : null,
                    metadataStatus: measurement.extensions?.metadata.status ?? 'not-started',
                    actionsStatus: measurement.extensions?.actions.status ?? 'not-started',
                    attachmentCountBucket: $28325260fc5afd05$var$attachmentCountBucket(measurement.attachmentCount),
                    navigation: measurement.navigation,
                    clockSource: measurement.clockSource
                }
            }
        }).fire();
    }, []);
    const settle = (0, $cozmU.useCallback)(()=>{
        const measurement = measurementRef.current;
        if (!measurement || measurement.identity !== identity || !measurement.active || measurement.completed || measurement.baseReadyTime === undefined || !measurement.extensions) return;
        const states = Object.values(measurement.extensions);
        const outcome = $28325260fc5afd05$var$getDiscoveryOutcome(states);
        if (outcome === 'success' && states.some(({ status: status })=>status === 'loading')) return;
        finish(measurement, outcome);
    }, [
        finish,
        identity
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hydrating || mode !== 'renderer' || !contentId || !macroId) return;
        let measurement = measurementRef.current;
        if (!measurement || measurement.identity !== identity) {
            const startTime = (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).getExperienceState(experienceName)?.startTime;
            measurement = {
                identity: identity,
                active: true,
                completed: false,
                startTime: startTime ?? performance.now(),
                clockSource: startTime === undefined ? 'renderer-mount' : 'macro-tracker',
                attachmentCount: 0,
                navigation: (0, $6VdZc.isInitial)() ? 'initial' : 'transition'
            };
            measurementRef.current = measurement;
            const pendingMeasurement = measurement;
            measurement.timer = setTimeout(()=>finish(pendingMeasurement, 'timeout'), $28325260fc5afd05$var$LOAD_TIMEOUT);
        }
        measurement.active = true;
        const activeMeasurement = measurement;
        return ()=>{
            activeMeasurement.active = false;
            // StrictMode replays effects synchronously. Let a replay reclaim this measurement.
            Promise.resolve().then(()=>{
                if (!activeMeasurement.active) finish(activeMeasurement, 'unmounted');
            });
        };
    }, [
        contentId,
        experienceName,
        finish,
        hydrating,
        identity,
        macroId,
        mode
    ]);
    (0, $cozmU.useEffect)(()=>{
        const measurement = measurementRef.current;
        if (!measurement || measurement.identity !== identity || measurement.completed) return;
        measurement.attachmentCount = attachmentCount;
        if (error) {
            finish(measurement, 'failure');
            return;
        }
        if (loading) return;
        if (measurement.baseReadyTime === undefined) {
            measurement.baseReadyTime = performance.now();
            (0, $ldKLB.addCustomSpans)('attachments-macro/base-ready', measurement.startTime, measurement.baseReadyTime);
        }
        measurement.extensions = attachmentCount === 0 ? $28325260fc5afd05$var$NO_EXTENSIONS : extensionStateRef.current?.identity === identity ? extensionStateRef.current.extensions : undefined;
        settle();
    }, [
        attachmentCount,
        error,
        finish,
        hydrating,
        identity,
        loading,
        settle
    ]);
    return (0, $cozmU.useCallback)((extensions)=>{
        if (identityRef.current !== identity) return;
        extensionStateRef.current = {
            identity: identity,
            extensions: extensions
        };
        const measurement = measurementRef.current;
        if (measurement?.identity === identity) measurement.extensions = extensions;
        // The parent data effect and all row commits must finish before we publish readiness.
        Promise.resolve().then(settle);
    }, [
        identity,
        settle
    ]);
};






var $ddsLC = parcelRequire("ddsLC");

const $0560855043126209$export$a5958f7fb393f63 = ({ legacyActions: legacyActions = (0, $ddsLC.DISABLED_ATTACHMENT_ACTION_LOAD_STATE), onState: onState })=>{
    const { metadata: metadata, eligibility: eligibility } = (0, $ddsLC.useAttachmentActionLoadState)();
    const actions = eligibility.status === 'disabled' ? legacyActions : eligibility;
    (0, $cozmU.useEffect)(()=>{
        onState({
            metadata: metadata,
            actions: actions
        });
    }, [
        actions,
        metadata,
        onState
    ]);
    return null;
};






var $jMyy4 = parcelRequire("jMyy4");


var $fUCKK = parcelRequire("fUCKK");




/**
 * Shared helpers for building attachment download URLs.
 * Used by AttachmentsTable and VersionHistory.
 */ /**
 * Strip an ARI prefix to get the bare Confluence entity ID.
 * e.g. "ari:cloud:confluence::content/12345" → "12345"
 */ const $938f1daee99da6d8$export$5511611cf607ba95 = (id)=>{
    const lastSlash = id.lastIndexOf('/');
    return lastSlash >= 0 ? id.slice(lastSlash + 1) : id;
};
const $938f1daee99da6d8$export$839894812e415e90 = (id)=>$938f1daee99da6d8$export$5511611cf607ba95(id);
const $938f1daee99da6d8$export$294caf8e77e086a1 = (pageId, fileName, version)=>{
    if (typeof window === 'undefined') return '';
    const base = `${window.location.origin}/wiki/download/attachments/${pageId}/${encodeURIComponent(fileName)}`;
    return version ? `${base}?version=${version}` : base;
};
const $938f1daee99da6d8$export$94bf3d6a75159b3c = (downloadPath)=>{
    if (typeof window === 'undefined') return '';
    return `${window.location.origin}/wiki${downloadPath}`;
};
const $938f1daee99da6d8$export$ab3bbcca4ee23e63 = (pageId, fileName, version, downloadPath)=>pageId ? $938f1daee99da6d8$export$294caf8e77e086a1(pageId, fileName, version) : $938f1daee99da6d8$export$94bf3d6a75159b3c(downloadPath);


// Flatten raw GraphQL attachment nodes into clean AttachmentItem objects
// so the UI doesn't have to deal with nested fragments/extensions.
// Turn the raw operations[] array into boolean permission flags.
// delete → canDelete, update → canEdit, read → canPreview + canView.
const $ccf18cfc0e72a10f$export$10eb4f54a3859f60 = (ops)=>{
    const has = (op)=>!!ops?.some((o)=>o?.operation === op);
    return {
        hasDeletePermission: has('delete'),
        hasEditPermission: has('update'),
        hasPreviewPermission: has('read'),
        hasViewPermission: has('read')
    };
};



var $bUIlA = parcelRequire("bUIlA");

const $cfd67d8c6a811bce$var$UNKNOWN_USER = {
    displayName: '',
    accountId: '',
    profilePicture: {
        path: ''
    }
};
// Convert raw Person → AttachmentUser. Returns empty user for anonymous.
const $cfd67d8c6a811bce$var$normalizeUser = (raw)=>{
    if (!raw) return $cfd67d8c6a811bce$var$UNKNOWN_USER;
    return {
        displayName: raw.displayName ?? '',
        accountId: raw.accountId ?? '',
        profilePicture: {
            path: raw.profilePicture?.path ?? ''
        }
    };
};
// Strip `?version=N` for a stable "latest version" download path.
const $cfd67d8c6a811bce$var$stripVersionParam = (downloadPath)=>{
    const idx = downloadPath.indexOf('?version=');
    return idx >= 0 ? downloadPath.slice(0, idx) : downloadPath;
};
const $cfd67d8c6a811bce$export$6f29ddb57f342c25 = (raw)=>{
    if (!raw || !raw.id || !raw.title) return null;
    const fileSize = Number((0, $bUIlA.getExtensionValue)(raw.extensions, 'fileSize') ?? 0);
    const mediaType = (0, $bUIlA.getExtensionValue)(raw.extensions, 'mediaType') ?? '';
    const fileId = (0, $bUIlA.getExtensionValue)(raw.extensions, 'fileId') ?? '';
    const downloadPath = raw.links?.download ?? '';
    const downloadPathWithoutVersion = $cfd67d8c6a811bce$var$stripVersionParam(downloadPath);
    const lastModificationDate = raw.version?.when ?? '';
    const lastModifier = $cfd67d8c6a811bce$var$normalizeUser(raw.version?.by ?? null);
    const creationDate = raw.history?.createdDate ?? '';
    const creator = $cfd67d8c6a811bce$var$normalizeUser(raw.history?.createdBy ?? null);
    const labels = raw.labels?.nodes?.flatMap((label)=>label?.name ? [
            label.name
        ] : []) ?? [];
    const permissions = (0, $ccf18cfc0e72a10f$export$10eb4f54a3859f60)(raw.operations);
    return {
        id: raw.id,
        fileId: fileId,
        fileName: raw.title,
        mediaType: mediaType,
        fileSize: fileSize,
        downloadPath: downloadPath,
        downloadPathWithoutVersion: downloadPathWithoutVersion,
        lastModificationDate: lastModificationDate,
        lastModifier: lastModifier,
        creationDate: creationDate,
        creator: creator,
        versionComment: raw.version?.message ?? '',
        version: raw.version?.number ?? 1,
        labels: labels,
        ...permissions
    };
};



var $ktrkx = parcelRequire("ktrkx");


var $lQOis = parcelRequire("lQOis");

const $839cdd6a6bc20038$var$DEFAULT_PAGE_SIZE = 500;
const $839cdd6a6bc20038$var$MAX_PAGE_SIZE = 500;
// Reuse the collator when sorting numbered filenames, matching the legacy macro.
const $839cdd6a6bc20038$var$attachmentNameCollator = new Intl.Collator(undefined, {
    numeric: true
});
const $839cdd6a6bc20038$export$a4c001b14047c450 = (params)=>{
    const patternsRaw = params.patterns?.value ?? '';
    const labelsRaw = params.labels?.value ?? '';
    const patterns = patternsRaw ? patternsRaw.split(',').reduce((acc, p)=>{
        const trimmed = p.trim();
        if (trimmed) acc.push(trimmed);
        return acc;
    }, []) : [];
    const labels = labelsRaw ? labelsRaw.split(',').reduce((acc, l)=>{
        const trimmed = l.trim();
        if (trimmed) acc.push(trimmed);
        return acc;
    }, []) : [];
    const showVersionHistory = params.old?.value !== 'false';
    const showUpload = params.upload?.value !== 'false';
    const showPreview = params.preview?.value === 'true';
    // The editor panel sends "Sort by" as `sort`; accept both.
    const sortByRaw = params.sortBy?.value ?? params.sort?.value;
    const sortBy = sortByRaw === 'date' || sortByRaw === 'createddate' || sortByRaw === 'size' || sortByRaw === 'name' ? sortByRaw : 'date';
    const sortOrderRaw = params.sortOrder?.value;
    const sortOrder = sortOrderRaw === 'ascending' || sortOrderRaw === 'descending' ? sortOrderRaw : 'ascending';
    // The editor panel sends "Number of items to display" as `num`; accept both.
    const pageSizeRaw = parseInt(params.pageSize?.value ?? params.num?.value ?? '', 10);
    const pageSize = !isNaN(pageSizeRaw) && pageSizeRaw > 0 ? Math.min(pageSizeRaw, $839cdd6a6bc20038$var$MAX_PAGE_SIZE) : $839cdd6a6bc20038$var$DEFAULT_PAGE_SIZE;
    return {
        patterns: patterns,
        labels: labels,
        showVersionHistory: showVersionHistory,
        sortBy: sortBy,
        sortOrder: sortOrder,
        showUpload: showUpload,
        showPreview: showPreview,
        pageRef: params.page?.value ?? undefined,
        pageSize: pageSize
    };
};
const $839cdd6a6bc20038$var$matchesPatterns = (fileName, patterns)=>{
    if (patterns.length === 0) return true;
    return patterns.some((rawPattern)=>{
        try {
            const pattern = rawPattern.startsWith('*') ? `.${rawPattern}` : rawPattern;
            return new RegExp(`^(?:${pattern})$`).test(fileName);
        } catch  {
            return false;
        }
    });
};
// AND logic: attachment must have ALL listed labels.
const $839cdd6a6bc20038$var$matchesLabels = (attachmentLabels, requiredLabels)=>{
    if (requiredLabels.length === 0) return true;
    const labelSet = new Set(attachmentLabels);
    return requiredLabels.every((label)=>labelSet.has(label));
};
const $839cdd6a6bc20038$var$sortAttachments = (attachments, sortBy, sortOrder)=>{
    return [
        ...attachments
    ].sort((a, b)=>{
        let comparison = 0;
        switch(sortBy){
            case 'date':
                comparison = new Date(a.lastModificationDate).getTime() - new Date(b.lastModificationDate).getTime();
                break;
            case 'createddate':
                comparison = new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime();
                break;
            case 'size':
                comparison = a.fileSize - b.fileSize;
                break;
            case 'name':
                comparison = $839cdd6a6bc20038$var$attachmentNameCollator.compare(a.fileName.toLowerCase(), b.fileName.toLowerCase());
                break;
        }
        return sortOrder === 'descending' ? -comparison : comparison;
    });
};
const $839cdd6a6bc20038$export$f1b2cc328921b868 = (params, contentId, hostSpaceKey)=>{
    const resolved = (0, $cozmU.useMemo)(()=>$839cdd6a6bc20038$export$a4c001b14047c450(params), [
        params
    ]);
    // Cross-page mode: resolve the target page's id by title.
    // Uses a dual-query fallback: both "split on colon" and "raw bare title" interpretations
    // are fetched in one request. Split is preferred; raw is the fallback (handles colons in titles).
    const crossPageTarget = (0, $cozmU.useMemo)(()=>resolved.pageRef ? (0, $lQOis.parsePageRef)(resolved.pageRef, hostSpaceKey) : null, [
        resolved.pageRef,
        hostSpaceKey
    ]);
    const isCrossPage = !!crossPageTarget?.rawTitle && !!crossPageTarget?.rawSpaceKey;
    const titleQuery = (0, $jMyy4.useQueryInterop)((0, $lQOis.USE_ATTACHMENTS_PAGE_BY_TITLE_QUERY), {
        variables: {
            rawSpaceKey: crossPageTarget?.rawSpaceKey ?? '',
            rawTitle: crossPageTarget?.rawTitle ?? '',
            splitSpaceKey: crossPageTarget?.splitSpaceKey ?? '',
            splitTitle: crossPageTarget?.splitTitle ?? '',
            hasSplit: crossPageTarget?.hasSplit ?? false
        },
        fetchPolicy: 'cache-first',
        skip: !isCrossPage,
        __callerPackage__: "attachments-macro"
    });
    // Resolution: prefer split (cross-space) result; fall back to raw (bare title in host space).
    // Case-insensitive title match (legacy is case-insensitive).
    const splitNode = titleQuery.data?.splitContent?.nodes?.[0];
    const rawNode = titleQuery.data?.rawContent?.nodes?.[0];
    const crossPageResolvedId = (0, $cozmU.useMemo)(()=>{
        // Try split interpretation first (e.g. "DEV:My Page" → space DEV, title "My Page")
        if (splitNode?.title && crossPageTarget?.splitTitle && splitNode.title.toLowerCase() === crossPageTarget.splitTitle.toLowerCase()) return splitNode.id ?? null;
        if (rawNode?.title && crossPageTarget?.rawTitle && rawNode.title.toLowerCase() === crossPageTarget.rawTitle.toLowerCase()) return rawNode.id ?? null;
        return null;
    }, [
        splitNode,
        rawNode,
        crossPageTarget
    ]);
    const crossPageNotFound = isCrossPage && !titleQuery.loading && !crossPageResolvedId;
    const effectiveContentId = isCrossPage ? crossPageResolvedId : contentId ?? null;
    const [sortBy, setSortBy] = (0, $cozmU.useState)(resolved.sortBy);
    const [sortOrder, setSortOrder] = (0, $cozmU.useState)(resolved.sortOrder);
    const [currentPage, setCurrentPage] = (0, $cozmU.useState)(1);
    // Sync sort state when macro params change (e.g. editor panel dropdown).
    (0, $cozmU.useEffect)(()=>{
        setSortBy(resolved.sortBy);
        setSortOrder(resolved.sortOrder);
        setCurrentPage(1);
    }, [
        resolved.sortBy,
        resolved.sortOrder
    ]);
    // Always fetch all attachments and paginate client-side, matching legacy behavior.
    // This gives us the true total upfront so all page numbers render immediately.
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $ktrkx.USE_ATTACHMENTS_MACRO_DATA_QUERY), {
        variables: {
            contentId: effectiveContentId ?? '',
            first: $839cdd6a6bc20038$var$DEFAULT_PAGE_SIZE,
            offset: 0,
            includeAttachmentActionContext: // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            (0, $9wGTI.fg)('forge_attachment_action_module_metadata') || (0, $9wGTI.fg)('forge_attachment_action')
        },
        fetchPolicy: 'cache-first',
        skip: !effectiveContentId,
        __callerPackage__: "attachments-macro"
    });
    // DSP check — defaults to false so downloads aren't transiently hidden.
    const { isDisabled: dspBlocksDownloads = false } = (0, $fUCKK.useIsAttachmentDownloadDisabled)({
        contentId: effectiveContentId ?? '',
        skip: !effectiveContentId
    });
    const rawPageId = data?.singleContent?.id ?? '';
    // AGG returns ARI format (ari:cloud:confluence::content/12345); download URLs need bare numeric ID.
    const pageId = (0, $938f1daee99da6d8$export$5511611cf607ba95)(rawPageId);
    const attachmentActionContext = (0, $cozmU.useMemo)(()=>{
        const targetContent = data?.singleContent;
        if (!pageId || !targetContent?.type || !targetContent.space?.id || !targetContent.space.key || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        !(0, $9wGTI.fg)('forge_attachment_action_module_metadata') && !(0, $9wGTI.fg)('forge_attachment_action')) return null;
        return {
            content: {
                id: pageId,
                type: targetContent.type,
                subtype: targetContent.subType ?? null
            },
            space: {
                id: (0, $938f1daee99da6d8$export$5511611cf607ba95)(targetContent.space.id),
                key: targetContent.space.key
            }
        };
    }, [
        data?.singleContent,
        pageId
    ]);
    const hasAttachFilePermission = data?.singleContent?.operations?.some((o)=>o?.operation?.toLowerCase() === 'create_attachment') ?? false;
    // Normalize raw GraphQL nodes; bad/redacted nodes are dropped.
    const allAttachments = (0, $cozmU.useMemo)(()=>{
        const nodes = data?.singleContent?.attachments?.nodes ?? [];
        return nodes.flatMap((node)=>{
            const normalized = (0, $cfd67d8c6a811bce$export$6f29ddb57f342c25)(node);
            return normalized ? [
                normalized
            ] : [];
        });
    }, [
        data
    ]);
    // Filter
    const filtered = (0, $cozmU.useMemo)(()=>allAttachments.filter((att)=>$839cdd6a6bc20038$var$matchesPatterns(att.fileName, resolved.patterns) && $839cdd6a6bc20038$var$matchesLabels(att.labels, resolved.labels)), [
        allAttachments,
        resolved.patterns,
        resolved.labels
    ]);
    // Sort client-side.
    const sorted = (0, $cozmU.useMemo)(()=>$839cdd6a6bc20038$var$sortAttachments(filtered, sortBy, sortOrder), [
        filtered,
        sortBy,
        sortOrder
    ]);
    // Client-side pagination: derive totalPages from the full filtered list,
    // then slice to the current page. This matches legacy behavior and gives
    // us the true total upfront so all page numbers render immediately.
    const totalCount = sorted.length;
    const totalPages = Math.max(1, Math.ceil(totalCount / resolved.pageSize));
    const hasNextPage = currentPage < totalPages;
    // Reset to page 1 when pageSize or content changes.
    const prevContentId = (0, $cozmU.useRef)(effectiveContentId);
    const prevPageSize = (0, $cozmU.useRef)(resolved.pageSize);
    (0, $cozmU.useEffect)(()=>{
        if (prevContentId.current !== effectiveContentId || prevPageSize.current !== resolved.pageSize) {
            prevContentId.current = effectiveContentId;
            prevPageSize.current = resolved.pageSize;
            setCurrentPage(1);
        }
    }, [
        effectiveContentId,
        resolved.pageSize
    ]);
    const safePage = Math.min(currentPage, totalPages);
    const pageStart = (safePage - 1) * resolved.pageSize;
    const attachments = sorted.slice(pageStart, pageStart + resolved.pageSize);
    const onSort = (0, $cozmU.useCallback)((column)=>{
        if (column === sortBy) setSortOrder((prev)=>prev === 'ascending' ? 'descending' : 'ascending');
        else {
            setSortBy(column);
            setSortOrder('ascending');
        }
        setCurrentPage(1);
    }, [
        sortBy
    ]);
    // Combine cross-page and main query loading/error states.
    const combinedLoading = loading || isCrossPage && titleQuery.loading;
    const combinedError = error ?? titleQuery.error ?? (crossPageNotFound ? new Error('attachments-macro: cross-page target not found') : null);
    return {
        attachments: attachments,
        attachmentActionContext: attachmentActionContext,
        totalCount: totalCount,
        currentPage: safePage,
        totalPages: totalPages,
        hasNextPage: hasNextPage,
        pageId: pageId,
        contentType: data?.singleContent?.type ?? null,
        contentSubtype: data?.singleContent?.subType ?? null,
        dspBlocksDownloads: dspBlocksDownloads,
        hasAttachFilePermission: hasAttachFilePermission,
        loading: combinedLoading,
        error: combinedError,
        sortBy: sortBy,
        sortOrder: sortOrder,
        onSort: onSort,
        onPageChange: setCurrentPage,
        showVersionHistory: resolved.showVersionHistory,
        showUpload: resolved.showUpload,
        showPreview: resolved.showPreview,
        refetch: refetch
    };
};


/* AttachmentsTable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");











var $1sCHt = parcelRequire("1sCHt");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $gC2EJ = parcelRequire("gC2EJ");


var $7vK9E = parcelRequire("7vK9E");








var $hBYtq = parcelRequire("hBYtq");








var $IOtUu = parcelRequire("IOtUu");


var $b3j2Y = parcelRequire("b3j2Y");


var $8aF6s = parcelRequire("8aF6s");


var $eFJfw = parcelRequire("eFJfw");


var $8WOej = parcelRequire("8WOej");


var $4vaoM = parcelRequire("4vaoM");


var $eATLT = parcelRequire("eATLT");


var $a6t12 = parcelRequire("a6t12");


var $jJK3p = parcelRequire("jJK3p");


var $jmjWc = parcelRequire("jmjWc");


const $498b4d3c7188a5fd$export$ac5b2e3000a234e6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "dv62p",
    name: "AttachmentsMacroDeleteDialogLoader",
    loader: async ()=>(await (parcelRequire("2NFTR"))).DeleteAttachmentDialog
});






const $75b321f55cb7410a$export$e7280d4558903aa6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qhrp1",
    name: "AttachmentsMacroEditPropertiesDialogLoader",
    loader: async ()=>(await (parcelRequire("3ouCR"))).EditAttachmentPropertiesDialog
});





/**
 * @generated SignedSource<<c73b84528b32969738991b784b8fc5a4>>
 * @relayHash 788b2558ba947f1feca9c76145ac9019
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 725fbd46a2bbd5c4e2910fd04de40d9b84fdd5fb72a23bf6fcbffc5862450003
const $065f117e617fa3b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "attachmentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "filter",
                    "variableName": "filter"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "attachmentId"
                }
            ],
            "concreteType": "ContentVersionHistoryConnection",
            "kind": "LinkedField",
            "name": "contentVersionHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentVersion",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "updatedTime"
                        },
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAttachmentVersionsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAttachmentVersionsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "788b2558ba947f1feca9c76145ac9019",
            "id": "725fbd46a2bbd5c4e2910fd04de40d9b84fdd5fb72a23bf6fcbffc5862450003",
            "metadata": {},
            "name": "useAttachmentVersionsQuery",
            "operationKind": "query",
            "text": "query useAttachmentVersionsQuery($attachmentId:ID!,$filter:ContentVersionHistoryFilter!){contentVersionHistory(id:$attachmentId,first:100,filter:$filter){nodes{number,updatedTime,author{id,displayName},message}}}"
        }
    };
}();
$065f117e617fa3b2$var$node.hash = "341106a5916dead04c88b1727c2fd806";
var $065f117e617fa3b2$export$2e2bcd8739ae039 = $065f117e617fa3b2$var$node;








const $175fcc2808c76aae$export$ba6e31ac6400cf6e = (0, $065f117e617fa3b2$export$2e2bcd8739ae039);
const $175fcc2808c76aae$export$72235b7881904a71 = (attachmentId, skip = false)=>{
    const shouldSkip = skip || !attachmentId;
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($175fcc2808c76aae$export$ba6e31ac6400cf6e, {
        variables: {
            attachmentId: attachmentId ?? '',
            filter: {
                contentType: 'attachment'
            }
        },
        fetchPolicy: 'cache-and-network',
        skip: shouldSkip,
        __callerPackage__: "attachments-macro"
    });
    const versions = (0, $cozmU.useMemo)(()=>{
        const rawNodes = data?.contentVersionHistory?.nodes ?? [];
        // Drop null nodes (DSP eviction / auth) and sort newest-first.
        const filtered = rawNodes.filter((n)=>Boolean(n));
        filtered.sort((a, b)=>(b.number ?? 0) - (a.number ?? 0));
        return filtered.map((node, index)=>{
            const modifier = {
                displayName: node.author?.displayName ?? '',
                accountId: node.author?.id ?? '',
                // profilePicture is required by AttachmentUser but the
                // `contentVersionHistory` doesn't expose it; default to empty path.
                profilePicture: {
                    path: ''
                }
            };
            return {
                version: node.number ?? 0,
                isLatestVersion: index === 0,
                isNew: (node.number ?? 0) === 1,
                comment: node.message ?? '',
                contentType: 'attachment',
                creationDate: node.updatedTime ?? '',
                modifier: modifier
            };
        });
    }, [
        data
    ]);
    return {
        versions: versions,
        loading: Boolean(loading && !data),
        error: error ?? null,
        refetch: refetch
    };
};






var $19aF3 = parcelRequire("19aF3");


var $cpjd2 = parcelRequire("cpjd2");

const $e36cf3ddad0b1ff1$export$7f3bc3bd0c27aea1 = ()=>{
    const [error, setError] = (0, $cozmU.useState)();
    const pending = (0, $cozmU.useRef)(false);
    const onPreviewClick = (0, $cozmU.useCallback)((event)=>{
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        // The plugin may already be loaded by another macro. Avoid opening it twice.
        event.stopPropagation();
        if (pending.current) return;
        const target = event.currentTarget;
        pending.current = true;
        setError(undefined);
        const onFailure = ()=>{
            pending.current = false;
            if (target.isConnected) setError(new Error('Unable to load the attachments macro preview'));
        };
        (0, $cpjd2.requireLegacyWRM)([
            'wr!com.atlassian.confluence.plugins.confluence-previews:confluence-previews-jquery'
        ], ()=>{
            if (!target.isConnected) {
                pending.current = false;
                return;
            }
            try {
                const preview = (0, $19aF3.globalRequire)('cp/confluence/preview');
                Promise.resolve(preview.loadConfluencePreviews(target)).catch(onFailure).finally(()=>{
                    pending.current = false;
                });
            } catch  {
                onFailure();
            }
        }, onFailure);
    }, []);
    return {
        onPreviewClick: onPreviewClick,
        error: error
    };
};
const $e36cf3ddad0b1ff1$export$eb84bb3611c34203 = (attachmentId)=>{
    if (!attachmentId) return attachmentId;
    const tail = attachmentId.includes('/') ? attachmentId.slice(attachmentId.lastIndexOf('/') + 1) : attachmentId;
    return /^att\d+$/.test(tail) ? tail.slice(3) : tail;
};
const $e36cf3ddad0b1ff1$export$b94bb2313d0cac15 = ({ pageId: pageId, attachmentId: attachmentId, fileName: fileName })=>`/${pageId}/${$e36cf3ddad0b1ff1$export$eb84bb3611c34203(attachmentId)}/${fileName}`;



/* AttachmentMacroForgeActions.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $7QUD1 = parcelRequire("7QUD1");


var $pM2s3 = parcelRequire("pM2s3");


var $9fBoq = parcelRequire("9fBoq");

const $6dfd382cfccf8db5$var$styles = {
    hiddenExtensionHost: "_3iDTPbYbGa"
};
const $6dfd382cfccf8db5$var$AttachmentActionButton = ({ extension: extension, onSelect: onSelect })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onSelect(extension);
    }, [
        extension,
        onSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: handleClick,
        testId: `forge-attachment-action-${extension.id}`
    }, (0, $9fBoq.extensionTitle)(extension));
};
const $6dfd382cfccf8db5$export$722bae195c30d653 = (props)=>{
    const { attachmentId: attachmentId, context: context, extensions: legacyExtensions } = props;
    const extensions = (0, $pM2s3.useEligibleAttachmentActions)(attachmentId, legacyExtensions); // Reset an open app when the attachment context or its eligible actions change.
    const contextKey = (0, $cozmU.useMemo)(()=>JSON.stringify([
            attachmentId,
            context.content,
            context.space,
            extensions.map(({ id: id })=>id)
        ]), [
        attachmentId,
        context.content,
        context.space,
        extensions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6dfd382cfccf8db5$var$EligibleActions, {
        key: contextKey,
        ...props,
        extensions: extensions
    });
};
const $6dfd382cfccf8db5$var$EligibleActions = ({ attachmentId: attachmentId, context: context, extensions: extensions })=>{
    const [activeExtension, setActiveExtension] = (0, $cozmU.useState)(null);
    const handleSelectExtension = (0, $cozmU.useCallback)((extension)=>{
        setActiveExtension(extension);
    }, []);
    const handleTearDown = (0, $cozmU.useCallback)(()=>{
        setActiveExtension(null);
    }, []);
    const extensionData = (0, $cozmU.useMemo)(()=>{
        const data = (0, $dYoxI.createAttachmentActionExtensionData)({
            attachmentId: attachmentId,
            content: context.content,
            space: context.space,
            surface: 'attachmentMacro'
        }); // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates -- independent rollback for the context field
        if ((0, $9wGTI.fg)('forge_attachment_action_context_title')) {
            if (typeof activeExtension?.properties?.title === 'string') return {
                ...data,
                title: activeExtension.properties.title
            };
        }
        return data;
    }, [
        attachmentId,
        context.content,
        context.space,
        activeExtension
    ]);
    if (!extensions.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, extensions.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6dfd382cfccf8db5$var$AttachmentActionButton, {
            key: extension.id,
            extension: extension,
            onSelect: handleSelectExtension
        })), activeExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6dfd382cfccf8db5$var$styles.hiddenExtensionHost
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.AttachmentActionForgeApp), {
        key: activeExtension.id,
        app: activeExtension,
        extensionData: extensionData,
        onTearDown: handleTearDown
    })));
};


/* AttachmentWebItems.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $kxhju = parcelRequire("kxhju");


var $eSLr0 = parcelRequire("eSLr0");


const $90b1591621582578$var$styles = {
    actionButton: "_2XghbEPgdg _0bjKvDKxmn _2sNsIgmnOE _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _23rrnHyKLB _4c065UPgdg _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc _0jFU0VoWWg _0KLXru66of _1UtDYzZpcK _1kk5Tkf7mX _1ANEUSLRg7 _0wOv4Q7zJH _2nTuUYZpcK _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _0clgaMZpcK _3sFUREiSCN _3gzVzLN4oS"
}; // webItemSections(<location>) returns EVERY web item at the location — including Confluence's own
// bundled attachment actions (edit/remove/preview), which the React macro already renders as native
// Preview/View/Properties/Delete buttons. Rendering those again would duplicate them, so we keep only
// third-party (Connect) app items. This prefix is how AFM identifies Connect app web items elsewhere
// (see filterConnectAppsFromExtensionPoints).
const $90b1591621582578$var$CONNECT_APP_KEY_PREFIX = 'com.atlassian.plugins.atlassian-connect-plugin:'; // The two per-attachment locations (`system.attachment` buttons and `system.attachment.metadata`
// lozenges) are fetched in a single batched WebItemLocation query keyed by the attachment content id
// — both slots issue this same query with identical variables, so Apollo dedupes them into one
// request per row. The legacy attachments macro only wires these two locations; `system.attachment`
// + `.metadata`. (`system.attachment.history` belongs to the separate view-attachments page, not the
// macro, so it is intentionally not handled here.)
const $90b1591621582578$var$ATTACHMENT_LOCATIONS = [
    (0, $eSLr0.SYSTEM_ATTACHMENT),
    (0, $eSLr0.SYSTEM_ATTACHMENT_METADATA)
]; // Each slot renders a different subset in a different part of the UI:
// its section equals that location or is prefixed by "<location>/". The `/` boundary matters because
// `system.attachment` is a string prefix of `system.attachment.metadata`. (Matches attachments-page.)
const $90b1591621582578$var$isItemAtLocation = (item, location)=>item.section === location || (item.section?.startsWith(`${location}/`) ?? false);
const $90b1591621582578$var$itemSlot = (item)=>{
    if ($90b1591621582578$var$isItemAtLocation(item, (0, $eSLr0.SYSTEM_ATTACHMENT_METADATA))) return 'metadata';
    if ($90b1591621582578$var$isItemAtLocation(item, (0, $eSLr0.SYSTEM_ATTACHMENT))) return 'actions';
    return null;
};
const $90b1591621582578$var$filterItemsForSlot = (webItems, slot)=>webItems.filter((item)=>$90b1591621582578$var$itemSlot(item) === slot);
// `has-custom-attributes: true`, exactly as the legacy #renderCustomAttributes macro gated it.
const $90b1591621582578$var$hasCustomAttributes = (item)=>item.params?.['has-custom-attributes'] === 'true'; // Strip the `attribute.` prefix so `attribute.data-linked-resource-id` becomes the real
// `data-linked-resource-id` DOM attribute (mirrors #renderCustomAttributes). Connect apps rely
// on these for their client-side click handling.
const $90b1591621582578$var$toCustomAttributes = (item)=>{
    const attributes = {};
    const params = item.params ?? {};
    Object.keys(params).forEach((key)=>{
        if (key.startsWith('attribute.')) attributes[key.slice('attribute.'.length)] = params[key];
    });
    return attributes;
};
const $90b1591621582578$var$IS_HTTP_URL = /^https?:\/\//; // Action button — mirrors the `system.attachment` loop in attachments-table.vm:
//   <a class="aui-button $styleClass" href="$url" [custom-attrs]>$label</a>
const $90b1591621582578$var$renderButton = (item)=>{
    const key = item.completeKey ?? item.id ?? item.url ?? item.label ?? '';
    const testId = `attachment-web-item-${item.completeKey ?? item.id ?? ''}`;
    const customAttributes = $90b1591621582578$var$hasCustomAttributes(item) ? $90b1591621582578$var$toCustomAttributes(item) : {};
    if (item.url) {
        if ($90b1591621582578$var$IS_HTTP_URL.test(item.url) && !item.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            key: key,
            href: item.url,
            testId: testId,
            ...customAttributes
        }, item.label);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
            key: key,
            href: item.url,
            className: (0, $hekY6.default)([
                $90b1591621582578$var$styles.actionButton,
                item.styleClass || undefined
            ]),
            "data-testid": testId,
            ...customAttributes
        }, item.label);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        key: key,
        type: "button",
        className: (0, $hekY6.default)([
            $90b1591621582578$var$styles.actionButton,
            item.styleClass || undefined
        ]),
        "data-testid": testId,
        ...customAttributes
    }, item.label);
}; // Shared inner content for metadata items, rendered inside either an <a> or a <span>.
const $90b1591621582578$var$renderMetadataContent = (item)=>{
    const iconClass = item.params?.['iconClass'];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, item.icon?.path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: "",
        src: item.icon.path,
        height: item.icon.height ?? undefined,
        width: item.icon.width ?? undefined
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, iconClass ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- legacy aui-iconfont icon class, matching renderItemSpan
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: `aui-icon aui-icon-small aui-iconfont-${iconClass}`
    }) : null, item.label));
};
const $90b1591621582578$var$renderMetadata = (item)=>{
    const key = `${item.completeKey}-${item.id}`;
    const testId = `attachment-web-item-${item.completeKey}-${item.id}`;
    const customAttributes = $90b1591621582578$var$hasCustomAttributes(item) ? $90b1591621582578$var$toCustomAttributes(item) : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        key: key,
        className: "filename"
    }, item.url ? // eslint-disable-next-line @atlaskit/design-system/no-html-anchor -- Connect web-item click delegation matches on the anchor's `ap-*` classes and reads its resolved href for context; the ADS Anchor strips className so it cannot be used here.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        id: item.id ?? undefined,
        href: item.url,
        title: item.tooltip ?? undefined,
        className: item.styleClass || undefined,
        "data-testid": testId,
        ...customAttributes
    }, $90b1591621582578$var$renderMetadataContent(item)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        id: item.id ?? undefined,
        title: item.tooltip ?? undefined,
        className: item.styleClass || undefined,
        "data-testid": testId,
        ...customAttributes
    }, $90b1591621582578$var$renderMetadataContent(item)));
}; // Renders the Connect app web items for a slot. Kept as its own component (rather than inline in the
// WebItemLocation render prop) so the Connect-app filter can be memoised — filtering in the render
// body trips the "expensive array method during render" lint.
const $90b1591621582578$var$AttachmentWebItemList = ({ webItems: webItems, slot: slot })=>{
    const items = (0, $cozmU.useMemo)(()=>{
        // Host actions are already rendered natively by the macro, so keep only Connect items to
        // avoid duplicating them, then narrow to the locations this slot renders.
        const connectItems = webItems.filter((item)=>item.completeKey?.startsWith($90b1591621582578$var$CONNECT_APP_KEY_PREFIX));
        return $90b1591621582578$var$filterItemsForSlot(connectItems, slot);
    }, [
        webItems,
        slot
    ]);
    if (items.length === 0) return null;
    const renderItem = slot === 'metadata' ? $90b1591621582578$var$renderMetadata : $90b1591621582578$var$renderButton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, items.map(renderItem));
}; /**
    * Renders the Connect/plugin web items for a single attachment at the per-attachment locations
    * (system.attachment, system.attachment.metadata) in a single batched query. The legacy attachments
    * macro rendered these server-side into the macro HTML; the migrated (React) macro fetches them via
    * WebItemLocation and reproduces the legacy markup (classes, icon, custom attributes) so appearance
    * and Connect JS hooks match. Pass `slot` to select which subset to render: `actions` (buttons) or
    * `metadata` (lozenges).
    */ 
const $90b1591621582578$export$9a616219d2c574be = ({ attachmentId: attachmentId, slot: slot })=>{
    // The GraphQL node id is an ARI/att-prefixed id; the backend ContentId scalar needs the bare
    // numeric attachment content id.
    const contentId = (0, $e36cf3ddad0b1ff1$export$eb84bb3611c34203)(attachmentId);
    if (!contentId) return null;
     // Pass ONLY contentId (the attachment). Do NOT pass spaceKey: the backend's getWebView
    // prioritises spaceKey and routes to forSpace(...), which never puts the attachment into
    // context. With contentId alone it takes forContent(attachmentId); the space is still resolved
    // server-side (an attachment is a SpaceContentEntityObject).
    // Typed explicitly: WebItemLocation's `children` prop is a union, so an inline callback's
    // `webItems` would otherwise fall back to `any` (TS7031).
    const renderWebItems = ({ webItems: webItems })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90b1591621582578$var$AttachmentWebItemList, {
            webItems: webItems,
            slot: slot
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
        location: $90b1591621582578$var$ATTACHMENT_LOCATIONS,
        contentId: contentId
    }, renderWebItems);
};








const $3f8404c735b4d0c7$var$DAY_MS = 86400000;
const $3f8404c735b4d0c7$export$359f3c271cd167e3 = (dateString, intl)=>{
    return intl.formatDate(new Date(dateString), {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};
const $3f8404c735b4d0c7$export$d1f5a2f86fcde3b5 = (dateString, intl)=>{
    const timestamp = new Date(dateString).getTime();
    const diffMs = Date.now() - timestamp;
    if (diffMs < $3f8404c735b4d0c7$var$DAY_MS) {
        const diffSeconds = Math.floor(diffMs / 1000);
        if (diffSeconds < 60) return intl.formatRelativeTime(-diffSeconds, 'second', {
            numeric: 'auto'
        });
        const diffMinutes = Math.floor(diffSeconds / 60);
        if (diffMinutes < 60) return intl.formatRelativeTime(-diffMinutes, 'minute', {
            numeric: 'auto'
        });
        const diffHours = Math.floor(diffMinutes / 60);
        return intl.formatRelativeTime(-diffHours, 'hour', {
            numeric: 'auto'
        });
    }
    return intl.formatDate(new Date(dateString), {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};


const $00897712c2a818f9$export$b42cbe5200b6a529 = ({ dateString: dateString })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [mounted, setMounted] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setMounted(true);
    }, []);
    const formatted = mounted ? (0, $3f8404c735b4d0c7$export$d1f5a2f86fcde3b5)(dateString, intl) : (0, $3f8404c735b4d0c7$export$359f3c271cd167e3)(dateString, intl);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatted);
};


/* VersionHistory.tsx generated by @compiled/babel-plugin v3.0.2 */ 































const $518c69f5d3dcd4ab$var$styles = {
    headingWrapper: "_0xmtkoPgdg",
    versionTable: "_39xV02N91d _2i6rxZQkF9 _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    versionLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzM7Tp",
    versionRow: "_3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
    versionNumCell: "_46hvQm2ADO _0xmtko2ADO _03SyCP5zaO _1ANEUSLRg7 _1RrJLiBwqQ _4ouGXI80Rt",
    versionCell: "_46hvQm2ADO _0xmtko2ADO _03SyCP5zaO _1RrJLiBwqQ",
    versionDateCell: "_46hvQm2ADO _0xmtko2ADO _03SyCPPgdg _1RrJLiBwqQ"
};
const $518c69f5d3dcd4ab$export$bc676b00e8f62584 = ({ attachmentId: attachmentId, versions: versions, contentId: contentId, fileName: fileName, dspBlocksDownloads: dspBlocksDownloads })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $518c69f5d3dcd4ab$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle",
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).versionHistory))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "table",
        xcss: $518c69f5d3dcd4ab$var$styles.versionTable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "tbody"
    }, versions.map((version)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "tr",
            key: version.version,
            xcss: $518c69f5d3dcd4ab$var$styles.versionRow,
            testId: `attachment-version-row-${attachmentId}-${version.version}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $518c69f5d3dcd4ab$var$styles.versionNumCell
        }, dspBlocksDownloads ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).version), " ", version.version), version.isLatestVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).currentVersion))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: contentId ? (0, $938f1daee99da6d8$export$294caf8e77e086a1)(contentId, fileName, version.version) : '',
            xcss: $518c69f5d3dcd4ab$var$styles.versionLink
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).version), " ", version.version), version.isLatestVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).currentVersion)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $518c69f5d3dcd4ab$var$styles.versionCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...version.isNew ? (0, $dJsIz.i18n).createdByUser : (0, $dJsIz.i18n).modifiedByUser,
            values: {
                userName: version.modifier.accountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                    userId: version.modifier.accountId,
                    fullName: version.modifier.displayName,
                    position: "bottom-start"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
                    userId: version.modifier.accountId,
                    fullName: version.modifier.displayName,
                    behavior: "link",
                    referralSource: "attachments-macro-version",
                    isUnderlinedByDefault: false
                })) : version.modifier.displayName
            }
        }))), version.comment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $518c69f5d3dcd4ab$var$styles.versionCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, version.comment)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $518c69f5d3dcd4ab$var$styles.versionDateCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $00897712c2a818f9$export$b42cbe5200b6a529), {
            dateString: version.creationDate
        }))))))));
};


const $611d5e7367d032a6$var$styles = {
    previewActionLink: "_0bjKvDKxmn _2sNsIgmnOE _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UFQfX _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc _0KLXru66of _1UtDYzZpcK _1kk5Tkf7mX _0wOv4Q7zJH _2nTuUYZpcK _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS",
    table: "_39xV02N91d _2i6rxZQkF9 _3Kbj8aIZbP",
    headerRow: "_0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67 _4auqkJNvrM _2yjt2x6wH8 _3mHaMX9r67",
    firstHeaderCell: "_4c065U2ADO _2fwxA57p2s _39xV02rXaT _0LQT5EPgdg _03SyCP2ADO _1RrJLit2nV",
    bodyCell: "_4c065U8HPE _2Y7lL42ADO _39xV02rXaT _4auqkJNvrM _2yjt2x6wH8 _3mHaMX9r67 _1RrJLit2nV",
    modifiedHeaderCell: "_4c065U2ADO _2fwxA57p2s _0LQT5ENHnM _03SyCP2ADO _1RrJLit2nV",
    modifiedBodyCell: "_4c065U8HPE _4auqkJNvrM _2yjt2x6wH8 _3mHaMX9r67 _0LQT5ENHnM _03SyCP2ADO _1RrJLit2nV",
    expandedCell: "_4c065UPgdg _2Y7lL4Pgdg _4auqkJNvrM _2yjt2x6wH8 _3mHaMX9r67",
    fileLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzM7Tp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    expandedDetailsWrapper: "_46hvQm8HPE _0xmtko5zaO _0LQT5ES40j _03SyCPNHnM",
    labelsContentIndent: "_0LQT5E1Y8M",
    previewContainer: "_4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrunmFW _39xV02E6Kk _1EqgXlN91d _0wOv4Q7zJH",
    previewImage: "_3iDTPbvLZJ _1EqgXlN91d _0NUa3rsz7G _39xV02IZbP _0jFU0VIZbP _00EA0egIor",
    previewFallback: "_46hvQm8HPE _0xmtko8HPE _0LQT5E5zaO _03SyCP5zaO _4ouGXIsz7G",
    expandButton: "_4FKVYE1Y8M _0wOv4Q7zJH _3iDTPbQ4SZ _0hPCNLDIqT _0KLXru66of",
    expandButtonSpacer: "_39xV02oWWg _3YEZNOdnbC"
};
// Download URL helpers are in ../downloadUrl.ts (shared with VersionHistory).
// Lazily fetches version history when a row is expanded.
// Shows every version (even single-version files) to match legacy behaviour.
const $611d5e7367d032a6$var$ExpandedVersionHistory = ({ attachment: attachment, contentId: contentId, dspBlocksDownloads: dspBlocksDownloads })=>{
    const { versions: versions } = (0, $175fcc2808c76aae$export$72235b7881904a71)(attachment.id);
    if (versions.length < 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $518c69f5d3dcd4ab$export$bc676b00e8f62584), {
        attachmentId: attachment.id,
        versions: versions,
        contentId: contentId,
        fileName: attachment.fileName,
        dspBlocksDownloads: dspBlocksDownloads
    });
};
const $611d5e7367d032a6$var$buildThumbnailUrl = (pageId, fileName, version)=>{
    if (typeof window === 'undefined' || !pageId) return '';
    const versionParam = version ? `?version=${version}` : '';
    return `${window.location.origin}/wiki/download/thumbnails/${pageId}/${encodeURIComponent(fileName)}${versionParam}`;
}; // Inline thumbnail preview. Falls back to a clickable card when the thumbnail 404s.
const $611d5e7367d032a6$var$InlineAttachmentPreview = ({ attachment: attachment, contentId: contentId, previewHref: previewHref, bareAttachmentId: bareAttachmentId, canPreview: canPreview, onPreviewClick: onPreviewClick })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [thumbnailFailed, setThumbnailFailed] = (0, $cozmU.useState)(false);
    if (!attachment.hasViewPermission) return null;
    const thumbnailUrl = $611d5e7367d032a6$var$buildThumbnailUrl(contentId, attachment.fileName, attachment.version);
    if (!thumbnailUrl) return null;
    const altText = intl.formatMessage((0, $dJsIz.i18n).inlinePreviewAlt, {
        fileName: attachment.fileName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        "data-testid": `attachments-preview-${attachment.id}`,
        href: canPreview ? previewHref : undefined,
        onClick: canPreview ? onPreviewClick : undefined,
        className: (0, $hekY6.default)([
            $611d5e7367d032a6$var$styles.previewContainer,
            "previewAttachmentLink"
        ]),
        "data-linked-resource-type": "attachment",
        "data-linked-resource-id": bareAttachmentId,
        "data-linked-resource-container-id": contentId,
        "data-linked-resource-default-alias": attachment.fileName,
        "data-linked-resource-content-type": attachment.mediaType ?? ''
    }, thumbnailFailed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $611d5e7367d032a6$var$styles.previewFallback,
        testId: `attachments-preview-fallback-${attachment.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, attachment.fileName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).preview)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "img",
        xcss: $611d5e7367d032a6$var$styles.previewImage,
        src: thumbnailUrl,
        alt: altText,
        loading: "lazy",
        onError: ()=>setThumbnailFailed(true)
    }));
};
const $611d5e7367d032a6$var$ExpandedRowDetails = ({ attachment: attachment, contentId: contentId, spaceKey: spaceKey, dspBlocksDownloads: dspBlocksDownloads, showPreview: showPreview, showVersionHistory: showVersionHistory, onAttachmentUpdated: onAttachmentUpdated, attachmentActionContext: attachmentActionContext, attachmentActionExtensions: attachmentActionExtensions = [] })=>{
    const intl = (0, $kSwu1.useIntl)();
    const editLabelsLabel = intl.formatMessage((0, $dJsIz.i18n).editLabels);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { onPreviewClick: onPreviewClick, error: previewError } = (0, $e36cf3ddad0b1ff1$export$7f3bc3bd0c27aea1)();
    const canPreview = Boolean(attachment.id && contentId);
    const bareAttachmentId = (0, $e36cf3ddad0b1ff1$export$eb84bb3611c34203)(attachment.id);
    const previewHref = contentId ? `/wiki/pages/viewpage.action?pageId=${encodeURIComponent(contentId)}&preview=${encodeURIComponent((0, $e36cf3ddad0b1ff1$export$b94bb2313d0cac15)({
        pageId: contentId,
        attachmentId: attachment.id,
        fileName: attachment.fileName
    }))}` : '#';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $611d5e7367d032a6$var$styles.expandedDetailsWrapper,
        testId: `attachments-detail-${attachment.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, previewError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: previewError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).previewLoadError))), showPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($611d5e7367d032a6$var$InlineAttachmentPreview, {
        attachment: attachment,
        contentId: contentId,
        previewHref: previewHref,
        bareAttachmentId: bareAttachmentId,
        canPreview: canPreview,
        onPreviewClick: onPreviewClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).labels)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $611d5e7367d032a6$var$styles.labelsContentIndent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, attachment.labels.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, attachment.labels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            key: label,
            text: label,
            href: (0, $eATLT.buildLabelUrl)(label, spaceKey),
            isRemovable: false,
            color: "grey"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).noLabels)), contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        label: editLabelsLabel,
        onClick: ()=>{
            showModal((0, $4vaoM.EditLabelDialogLoader), {
                contentId: attachment.id,
                spaceKey: spaceKey ?? '',
                source: 'attachmentsMacro',
                onCloseComplete: onAttachmentUpdated
            });
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        label: editLabelsLabel,
        isDisabled: true
    })))), showVersionHistory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($611d5e7367d032a6$var$ExpandedVersionHistory, {
        key: `${attachment.id}-${attachment.version}-${attachment.versionComment}`,
        attachment: attachment,
        contentId: contentId,
        dspBlocksDownloads: dspBlocksDownloads
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, canPreview && attachment.hasPreviewPermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        href: previewHref,
        onClick: onPreviewClick,
        className: (0, $hekY6.default)([
            $611d5e7367d032a6$var$styles.previewActionLink,
            "previewAttachmentLink"
        ]),
        "data-linked-resource-type": "attachment",
        "data-linked-resource-id": bareAttachmentId,
        "data-linked-resource-container-id": contentId,
        "data-linked-resource-default-alias": attachment.fileName,
        "data-linked-resource-content-type": attachment.mediaType ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).preview)), canPreview && attachment.hasViewPermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        href: previewHref,
        onClick: onPreviewClick,
        className: (0, $hekY6.default)([
            $611d5e7367d032a6$var$styles.previewActionLink,
            "previewAttachmentLink"
        ]),
        "data-linked-resource-type": "attachment",
        "data-linked-resource-id": bareAttachmentId,
        "data-linked-resource-container-id": contentId,
        "data-linked-resource-default-alias": attachment.fileName,
        "data-linked-resource-content-type": attachment.mediaType ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).view)), (attachment.hasEditPermission || attachment.hasDeletePermission) && contentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, attachment.hasEditPermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: ()=>{
            showModal((0, $75b321f55cb7410a$export$e7280d4558903aa6), {
                contentId: contentId,
                attachment: {
                    title: attachment.fileName,
                    extensions: [
                        {
                            key: 'mediaType',
                            value: attachment.mediaType ?? ''
                        },
                        {
                            key: 'comment',
                            value: attachment.versionComment ?? ''
                        }
                    ]
                },
                attachmentId: attachment.id,
                labels: attachment.labels,
                spaceKey: spaceKey ?? '',
                handleAttachmentUpdated: onAttachmentUpdated ?? (()=>{})
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).properties)), attachment.hasDeletePermission && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        spacing: "compact",
        onClick: ()=>{
            showModal((0, $498b4d3c7188a5fd$export$ac5b2e3000a234e6), {
                attachmentId: attachment.id,
                attachmentName: attachment.fileName,
                onDeleted: onAttachmentUpdated
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).deleteAttachment))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90b1591621582578$export$9a616219d2c574be), {
        attachmentId: attachment.id,
        slot: "actions"
    }), attachmentActionContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6dfd382cfccf8db5$export$722bae195c30d653), {
        attachmentId: attachment.id,
        context: attachmentActionContext,
        extensions: attachmentActionExtensions
    }))));
};
const $611d5e7367d032a6$export$4669696b373a5d47 = ({ attachments: attachments, dspBlocksDownloads: dspBlocksDownloads, showVersionHistory: showVersionHistory, showPreview: showPreview, contentId: contentId, spaceKey: spaceKey, onAttachmentUpdated: onAttachmentUpdated, attachmentActionContext: attachmentActionContext, attachmentActionExtensions: attachmentActionExtensions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [expandedIds, setExpandedIds] = (0, $cozmU.useState)(new Set()); // Keep the clicked row pinned when expanding/collapsing (content grows downward).
    const expandAnchorRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const anchor = expandAnchorRef.current;
        if (!anchor) return;
        expandAnchorRef.current = null;
        const delta = anchor.el.getBoundingClientRect().top - anchor.top;
        if (delta === 0) return;
        let node = anchor.el.parentElement;
        while(node){
            const { overflowY: overflowY } = window.getComputedStyle(node);
            if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
                node.scrollTop += delta;
                return;
            }
            node = node.parentElement;
        }
        window.scrollBy(0, delta);
    }, [
        expandedIds
    ]);
    const toggleExpand = (id, trigger)=>{
        expandAnchorRef.current = {
            el: trigger,
            top: trigger.getBoundingClientRect().top
        };
        setExpandedIds((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: "plugin_attachments_container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "table",
        xcss: $611d5e7367d032a6$var$styles.table,
        testId: "attachments-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "thead"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "tr",
        xcss: $611d5e7367d032a6$var$styles.headerRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "th",
        xcss: $611d5e7367d032a6$var$styles.firstHeaderCell,
        scope: 'col'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).columnName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "th",
        xcss: $611d5e7367d032a6$var$styles.modifiedHeaderCell,
        scope: 'col'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).columnModified))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "tbody"
    }, attachments.flatMap((attachment)=>{
        const isExpanded = expandedIds.has(attachment.id);
        const mainRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "tr",
            key: attachment.id,
            testId: `attachments-row-${attachment.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $611d5e7367d032a6$var$styles.bodyCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            shouldWrap: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            type: "button",
            "aria-expanded": isExpanded,
            "aria-label": intl.formatMessage(isExpanded ? (0, $dJsIz.i18n).collapseVersionHistory : (0, $dJsIz.i18n).expandVersionHistory, {
                fileName: attachment.fileName
            }),
            onClick: (event)=>toggleExpand(attachment.id, event.currentTarget),
            xcss: $611d5e7367d032a6$var$styles.expandButton,
            testId: `attachments-expand-${attachment.id}`
        }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8WOej.AttachmentIcon), {
            mediaType: attachment.mediaType,
            title: attachment.fileName,
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            shouldWrap: true
        }, dspBlocksDownloads ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, attachment.fileName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            href: (0, $938f1daee99da6d8$export$ab3bbcca4ee23e63)(contentId, attachment.fileName, attachment.version, attachment.downloadPath),
            xcss: $611d5e7367d032a6$var$styles.fileLink,
            testId: `attachments-link-${attachment.id}`
        }, attachment.fileName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFJfw.AttachmentActionMetadata), {
            attachmentId: attachment.id
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90b1591621582578$export$9a616219d2c574be), {
            attachmentId: attachment.id,
            slot: "metadata"
        })), attachment.versionComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, attachment.versionComment) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $611d5e7367d032a6$var$styles.modifiedBodyCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dJsIz.i18n).dateByUser,
            values: {
                date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $00897712c2a818f9$export$b42cbe5200b6a529), {
                    dateString: attachment.lastModificationDate
                }),
                userName: attachment.lastModifier.accountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                    userId: attachment.lastModifier.accountId,
                    fullName: attachment.lastModifier.displayName,
                    position: "bottom-start"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
                    userId: attachment.lastModifier.accountId,
                    fullName: attachment.lastModifier.displayName,
                    behavior: "link",
                    referralSource: "attachments-macro",
                    isUnderlinedByDefault: false
                })) : attachment.lastModifier.displayName
            }
        }))));
        if (!isExpanded) return [
            mainRow
        ];
        const expandedRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "tr",
            key: `${attachment.id}-expanded`,
            testId: `attachments-row-${attachment.id}-expanded`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            xcss: $611d5e7367d032a6$var$styles.expandedCell,
            colSpan: 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($611d5e7367d032a6$var$ExpandedRowDetails, {
            attachment: attachment,
            contentId: contentId,
            spaceKey: spaceKey,
            dspBlocksDownloads: dspBlocksDownloads,
            showPreview: showPreview,
            showVersionHistory: showVersionHistory,
            onAttachmentUpdated: onAttachmentUpdated,
            attachmentActionContext: attachmentActionContext,
            attachmentActionExtensions: attachmentActionExtensions
        })));
        return [
            mainRow,
            expandedRow
        ];
    })))));
};


/* DownloadAllLink.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $6Fmj3 = parcelRequire("6Fmj3");













const $f5b9146798ce3e3e$var$DOWNLOAD_ALL_PATH = '/wiki/download/all_attachments';
const $f5b9146798ce3e3e$var$styles = {
    wrapper: "_46hvQm8HPE",
    link: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbccYA _0hPCNLDIqT _1UtDYzM7Tp"
};
const $f5b9146798ce3e3e$export$5be0a2f9f1b8b1dd = ({ pageId: pageId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const href = `${$f5b9146798ce3e3e$var$DOWNLOAD_ALL_PATH}?pageId=${pageId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5b9146798ce3e3e$var$styles.wrapper,
        testId: "attachments-download-all"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: href,
        title: formatMessage((0, $dJsIz.i18n).downloadAllDesc),
        xcss: $f5b9146798ce3e3e$var$styles.link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).downloadAll))));
};

















const $f5bf95bf72494088$export$fddf379e22a74b00 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "attachments-empty-state",
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).noAttachments)));






const $584b28363e3351a4$export$d436ae89c1f2e9e9 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "iFOsl",
    name: "AttachmentsMacroUploadLoader",
    loader: async ()=>(await (parcelRequire("aJ4wx"))).AttachmentsMacroUpload
});


const $f90b58b6141ee4f5$var$EMPTY_PARAMS = {};
const $f90b58b6141ee4f5$var$ACCESS_UNAVAILABLE_ACTIONS = {
    status: 'access-unavailable',
    hasExtensions: false
};
const $f90b58b6141ee4f5$var$AttachmentsMacroTableWithoutForgeActions = ({ onExtensionState: onExtensionState, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $611d5e7367d032a6$export$4669696b373a5d47), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0560855043126209$export$a5958f7fb393f63), {
        onState: onExtensionState
    }));
const $f90b58b6141ee4f5$var$AttachmentsMacroTableWithDiscoveredForgeActions = (props)=>{
    const { extensions: extensions, loading: loading, error: extensionError } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION),
        contentId: props.contentId,
        spaceKey: props.spaceKey,
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        skipQuery: (0, $9wGTI.fg)('forge_attachment_display_conditions')
    });
    const attachmentActionExtensions = (0, $cozmU.useMemo)(()=>loading || extensionError ? [] : (0, $dYoxI.filterAttachmentActionExtensions)(extensions), [
        extensionError,
        extensions,
        loading
    ]);
    const { onExtensionState: onExtensionState, ...tableProps } = props;
    const legacyActions = (0, $cozmU.useMemo)(()=>({
            status: loading ? 'loading' : extensionError ? 'failure' : 'success',
            hasExtensions: attachmentActionExtensions.length > 0
        }), [
        attachmentActionExtensions.length,
        extensionError,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $611d5e7367d032a6$export$4669696b373a5d47), {
        ...tableProps,
        attachmentActionExtensions: attachmentActionExtensions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0560855043126209$export$a5958f7fb393f63), {
        legacyActions: legacyActions,
        onState: onExtensionState
    }));
};
const $f90b58b6141ee4f5$var$AttachmentsMacroTableWithForgeActions = (props)=>{
    const renderNoAccessFallback = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $611d5e7367d032a6$export$4669696b373a5d47), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0560855043126209$export$a5958f7fb393f63), {
            legacyActions: $f90b58b6141ee4f5$var$ACCESS_UNAVAILABLE_ACTIONS,
            onState: props.onExtensionState
        })), [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mcHd.ForgeUIExtensionProviderWrapper), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION),
        noAccessRenderFallback: renderNoAccessFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f90b58b6141ee4f5$var$AttachmentsMacroTableWithDiscoveredForgeActions, props));
};
const $f90b58b6141ee4f5$var$AttachmentsMacroTable = (props)=>{
    if (// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    !(0, $9wGTI.fg)('forge_attachment_action') || !props.contentId || !props.spaceKey || !props.attachmentActionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f90b58b6141ee4f5$var$AttachmentsMacroTableWithoutForgeActions, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f90b58b6141ee4f5$var$AttachmentsMacroTableWithForgeActions, {
        ...props,
        contentId: props.contentId,
        spaceKey: props.spaceKey
    });
};
const $f90b58b6141ee4f5$var$AttachmentsMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node);
    const { attachments: attachments, attachmentActionContext: attachmentActionContext, totalCount: totalCount, currentPage: currentPage, totalPages: totalPages, hasNextPage: hasNextPage, pageId: pageId, dspBlocksDownloads: dspBlocksDownloads, error: // hasAttachFilePermission not used — upload permission is enforced server-side.
    error, loading: loading, onPageChange: onPageChange, showVersionHistory: showVersionHistory, showUpload: showUpload, showPreview: showPreview, refetch: refetch } = (0, $839cdd6a6bc20038$export$f1b2cc328921b868)(macroParams ?? $f90b58b6141ee4f5$var$EMPTY_PARAMS, contentId, spaceKey ?? undefined);
    const onExtensionState = (0, $28325260fc5afd05$export$7157f6971a221bee)({
        contentId: contentId,
        macroId: typeof attributes.macroId === 'string' ? attributes.macroId : '',
        experienceName: experienceName,
        mode: mode,
        loading: loading,
        error: error,
        attachmentCount: attachments.length
    });
    const attachmentIds = (0, $cozmU.useMemo)(()=>attachments.map(({ id: id })=>id), [
        attachments
    ]);
    const handleAttachmentUpdated = (0, $cozmU.useCallback)(()=>{
        refetch?.();
    }, [
        refetch
    ]);
    const handlePageClick = (0, $cozmU.useCallback)((p)=>()=>onPageChange(p), [
        onPageChange
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.300",
        testId: "attachments-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).errorGeneric)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes,
        error: error
    }));
    const isEmpty = attachments.length === 0;
    const showEmptyState = isEmpty;
    const showDownloadAll = totalCount > 1 && !dspBlocksDownloads;
    // Show the upload area when the macro param enables it. Permission is
    // enforced server-side on the upload POST (403 → error state).
    const showUploadArea = showUpload && Boolean(contentId);
    const pages = Array.from({
        length: totalPages
    }, (_, i)=>i + 1);
    const showPagination = totalPages > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "attachments-macro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, showEmptyState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5bf95bf72494088$export$fddf379e22a74b00), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brERQ.AttachmentActionEligibilityProvider), {
        attachmentIds: attachmentIds,
        content: attachmentActionContext?.content ?? {},
        space: attachmentActionContext?.space ?? {},
        surface: "attachmentMacro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f90b58b6141ee4f5$var$AttachmentsMacroTable, {
        onExtensionState: onExtensionState,
        attachments: attachments,
        dspBlocksDownloads: dspBlocksDownloads,
        showVersionHistory: showVersionHistory,
        showPreview: showPreview,
        contentId: pageId || contentId || undefined,
        spaceKey: attachmentActionContext?.space.key ?? spaceKey ?? undefined,
        attachmentActionContext: attachmentActionContext ?? undefined,
        onAttachmentUpdated: handleAttachmentUpdated
    })), showPagination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        testId: "attachments-pagination"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: currentPage <= 1,
        onClick: ()=>onPageChange(currentPage - 1),
        testId: "attachments-pagination-prev"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).paginationPrev)), pages.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            key: p,
            appearance: "subtle",
            spacing: "compact",
            isSelected: p === currentPage,
            onClick: handlePageClick(p),
            testId: `attachments-pagination-page-${p}`
        }, p)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: currentPage >= totalPages && !hasNextPage,
        onClick: ()=>onPageChange(currentPage + 1),
        testId: "attachments-pagination-next"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).paginationNext)))), showUploadArea && contentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $584b28363e3351a4$export$d436ae89c1f2e9e9), {
        contentId: contentId,
        onFilesUploaded: handleAttachmentUpdated
    }), showDownloadAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5b9146798ce3e3e$export$5be0a2f9f1b8b1dd), {
        pageId: pageId
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
const $f90b58b6141ee4f5$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dJsIz.i18n).errorGeneric);
const $f90b58b6141ee4f5$export$983565c6d2beb10 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $f90b58b6141ee4f5$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f90b58b6141ee4f5$var$AttachmentsMacroRendererComponent, props));
module.exports["AttachmentsMacroRenderer"] = $f90b58b6141ee4f5$export$983565c6d2beb10;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("dJsIz", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ada0102ecadc3b3d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    noAttachments: {
        id: "attachments-macro.no-attachments",
        defaultMessage: "There are currently no attachments on this page."
    },
    download: {
        id: "attachments-macro.download",
        defaultMessage: "Download"
    },
    version: {
        id: "attachments-macro.version",
        defaultMessage: "Version"
    },
    currentVersion: {
        id: "attachments-macro.current-version",
        defaultMessage: "(current version)"
    },
    dateByUser: {
        id: "attachments-macro.date-by-user",
        defaultMessage: "{date} by {userName}"
    },
    modifiedByUser: {
        id: "attachments-macro.modified-by-user",
        defaultMessage: "Modified by {userName}"
    },
    createdByUser: {
        id: "attachments-macro.created-by-user",
        defaultMessage: "Created by {userName}"
    },
    versionHistory: {
        id: "attachments-macro.version-history",
        defaultMessage: "Version history"
    },
    labels: {
        id: "attachments-macro.labels",
        defaultMessage: "Labels"
    },
    noLabels: {
        id: "attachments-macro.no-labels",
        defaultMessage: "No labels"
    },
    editLabels: {
        id: "attachments-macro.edit-labels",
        defaultMessage: "Edit labels"
    },
    paginationPrev: {
        id: "attachments-macro.pagination.prev",
        defaultMessage: "Prev"
    },
    paginationNext: {
        id: "attachments-macro.pagination.next",
        defaultMessage: "Next"
    },
    previewLoadError: {
        id: "attachments-macro.preview-load-error",
        defaultMessage: "We couldn\u2019t open the preview. Please try again."
    },
    preview: {
        id: "attachments-macro.preview",
        defaultMessage: "Preview"
    },
    inlinePreviewAlt: {
        id: "attachments-macro.inline-preview-alt",
        defaultMessage: "Preview of {fileName}"
    },
    view: {
        id: "attachments-macro.view",
        defaultMessage: "View"
    },
    properties: {
        id: "attachments-macro.properties",
        defaultMessage: "Properties"
    },
    deleteAttachment: {
        id: "attachments-macro.delete",
        defaultMessage: "Delete"
    },
    errorGeneric: {
        id: "attachments-macro.error-generic",
        defaultMessage: "Error retrieving attachments"
    },
    errorPageNotFound: {
        id: "attachments-macro.error-page-not-found",
        defaultMessage: "Item not found: {pageTitle}"
    },
    errorNoPagePermission: {
        id: "attachments-macro.error-no-page-permission",
        defaultMessage: "Restrictions have been applied that limit access to this content: {pageTitle}"
    },
    downloadAll: {
        id: "attachments-macro.download-all",
        defaultMessage: "Download All"
    },
    downloadAllDesc: {
        id: "attachments-macro.download-all-desc",
        defaultMessage: "Download all attachments"
    },
    loading: {
        id: "attachments-macro.loading",
        defaultMessage: "Loading attachments\u2026"
    },
    columnName: {
        id: "attachments-macro.column-name",
        defaultMessage: "File"
    },
    expandVersionHistory: {
        id: "attachments-macro.expand-version-history",
        defaultMessage: "Expand version history for {fileName}"
    },
    collapseVersionHistory: {
        id: "attachments-macro.collapse-version-history",
        defaultMessage: "Collapse version history for {fileName}"
    },
    columnModified: {
        id: "attachments-macro.column-modified",
        defaultMessage: "Modified"
    },
    columnAuthor: {
        id: "attachments-macro.column-author",
        defaultMessage: "Author"
    },
    columnExpandToggle: {
        id: "attachments-macro.column-expand-toggle",
        defaultMessage: "Expand attachment details"
    }
});
module.exports["i18n"] = $ada0102ecadc3b3d$export$a7357cdd1f0b0168;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("fUCKK", function(module, exports) {

var $2AVi4 = parcelRequire("2AVi4");


var $jMyy4 = parcelRequire("jMyy4");

const $d8595d0fc7bd685e$var$useIsAttachmentDownloadDisabledQuery = (0, $2AVi4.default);
const $d8595d0fc7bd685e$export$11481e5f9bc98634 = (action, contentId, spaceKey)=>({
        action: action,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        spaceKey: spaceKey
    });
const $d8595d0fc7bd685e$export$f8ce0f983169a841 = ({ contentId: contentId, spaceKey: spaceKey, skip: skip })=>{
    const action = 'ATTACHMENT_DOWNLOAD';
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($d8595d0fc7bd685e$var$useIsAttachmentDownloadDisabledQuery, {
        variables: $d8595d0fc7bd685e$export$11481e5f9bc98634(action, contentId, spaceKey),
        context: {
            allowOnExternalPage: true
        },
        skip: skip,
        __callerPackage__: "data-security"
    });
    const allowedResp = data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    // Defaults to disabled if we don't have a definitive answer
    const isDisabled = allowedResp === undefined || allowedResp === null ? true : !allowedResp;
    return {
        isDisabled: isDisabled,
        loading: loading,
        error: error
    };
};
module.exports["useIsAttachmentDownloadDisabled"] = $d8595d0fc7bd685e$export$f8ce0f983169a841;

});

parcelRegister("2AVi4", function(module, exports) {
/**
 * @generated SignedSource<<512a8f8de84275c8711ae7d5f2eee090>>
 * @relayHash 978334c7a56389878fe12e353224c5fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b52b2cd2f09302e89f948c3933b5eded67abf62d74d6bcf7400ae8c36d1ed238
const $687cac4df14cb915$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsAttachmentDownloadDisabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsAttachmentDownloadDisabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "978334c7a56389878fe12e353224c5fb",
            "id": "b52b2cd2f09302e89f948c3933b5eded67abf62d74d6bcf7400ae8c36d1ed238",
            "metadata": {},
            "name": "useIsAttachmentDownloadDisabledQuery",
            "operationKind": "query",
            "text": "query useIsAttachmentDownloadDisabledQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$687cac4df14cb915$var$node.hash = "c2b35f4574dc5079df90541fabaaf6f9";
var $687cac4df14cb915$export$2e2bcd8739ae039 = $687cac4df14cb915$var$node;
module.exports["default"] = $687cac4df14cb915$export$2e2bcd8739ae039;

});

parcelRegister("bUIlA", function(module, exports) {
/**
 * Extract a value from the Confluence `Content.extensions` array.
 *
 * The AGG schema has NO standalone `type Attachment` — attachments are
 * `Content` nodes with `type: "attachment"`. File metadata like `fileSize`
 * and `mediaType` lives inside the generic `extensions: [KeyValueHierarchyMap]`
 * array rather than as first-class fields.
 *
 * See PROGRESS.md §27.1–27.2 and GRAPHQL_PLAN.md §0.3 for the schema rationale.
 *
 * Mirrors `confluence/next/packages/attachments-page/src/attachmentUtils.ts:27`
 * but with stricter null-tolerance to match the generated Relay types
 * (`{ readonly key: string | null; readonly value: string | null } | null`).
 *
 * @example
 *   const fileSize = Number(getExtensionValue(node.extensions, 'fileSize') ?? 0);
 *   const mediaType = getExtensionValue(node.extensions, 'mediaType') ?? '';
 */ const $c189e18d14f81dcb$export$223cab2cadce220 = (extensions, key)=>{
    if (!extensions) return null;
    const entry = extensions.find((e)=>e?.key === key);
    return entry?.value ?? null;
};
module.exports["getExtensionValue"] = $c189e18d14f81dcb$export$223cab2cadce220;

});

parcelRegister("8WOej", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqehY = parcelRequire("iqehY");


var $9TA3F = parcelRequire("9TA3F");


var $9Jnyo = parcelRequire("9Jnyo");


var $gCdaE = parcelRequire("gCdaE");


var $1kVaD = parcelRequire("1kVaD");


var $67SYT = parcelRequire("67SYT");


var $5t27u = parcelRequire("5t27u");


var $cAa12 = parcelRequire("cAa12");


var $EhIdb = parcelRequire("EhIdb");


var $gCL8n = parcelRequire("gCL8n");


var $1rDre = parcelRequire("1rDre");


var $4C7IM = parcelRequire("4C7IM");


var $8B1YK = parcelRequire("8B1YK");


var $90EXt = parcelRequire("90EXt");


var $aeJll = parcelRequire("aeJll");


var $6lknI = parcelRequire("6lknI");


var $fxeqy = parcelRequire("fxeqy");


var $42Fpa = parcelRequire("42Fpa");


var $eziPO = parcelRequire("eziPO");


var $5Dz6O = parcelRequire("5Dz6O");


var $8If3N = parcelRequire("8If3N");


var $fGSwx = parcelRequire("fGSwx");

const $403c9cfb5b020557$export$c647cb0ee6e282fe = [
    'small',
    'medium'
];
const $403c9cfb5b020557$var$AttachmentFileExtensionMatchers = [
    {
        regexp: /\.(pdf)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($8B1YK))),
            (0, (/*@__PURE__*/$parcel$interopDefault($90EXt)))
        ]
    },
    {
        regexp: /\.(gif)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($EhIdb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gCL8n)))
        ]
    },
    {
        regexp: /\.(jpeg|jpg|png)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1rDre))),
            (0, (/*@__PURE__*/$parcel$interopDefault($4C7IM)))
        ]
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
            (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
        ]
    },
    {
        regexp: /\.(zip|tar|gz|bz2|rar)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
            (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
        ]
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
            (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
        ]
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
            (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
        ]
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
        ]
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
        ]
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
            (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
        ]
    }
];
const $403c9cfb5b020557$export$724dbd38c6f8ef0 = {
    'application/pdf': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8B1YK))),
        (0, (/*@__PURE__*/$parcel$interopDefault($90EXt)))
    ],
    'image/gif': [
        (0, (/*@__PURE__*/$parcel$interopDefault($EhIdb))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCL8n)))
    ],
    'image/jpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1rDre))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4C7IM)))
    ],
    'image/png': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1rDre))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4C7IM)))
    ],
    'text/xml': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/html': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/css': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/javascript': [
        (0, (/*@__PURE__*/$parcel$interopDefault($fxeqy))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42Fpa)))
    ],
    'text/plain': [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ],
    //NEED TO GIVE THIS AN ICON,
    'application/zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/x-zip': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/x-zip-compressed': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/java-archive': [
        (0, (/*@__PURE__*/$parcel$interopDefault($iqehY))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9TA3F)))
    ],
    'application/vnd.ms-excel': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    ],
    'application/vnd.ms-powerpoint': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/msword': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($1kVaD))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67SYT)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($aeJll))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6lknI)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': [
        (0, (/*@__PURE__*/$parcel$interopDefault($8If3N))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fGSwx)))
    ],
    'application/x-shockwave-flash': [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ],
    //NEED TO GIVE THIS AN ICON
    'video/quicktime': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'audio/x-ms-wma': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'audio/x-ms-wmv': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'video/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'audio/x-pn-realaudio': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'application/vnd.rn-realmedia': [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ],
    //NEED TO GIVE THIS AN ICON
    'audio/mpeg': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'video/x-msvideo': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'video/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($eziPO))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5Dz6O)))
    ],
    'audio/mp4': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    'audio/mp3': [
        (0, (/*@__PURE__*/$parcel$interopDefault($9Jnyo))),
        (0, (/*@__PURE__*/$parcel$interopDefault($gCdaE)))
    ],
    default: [
        (0, (/*@__PURE__*/$parcel$interopDefault($5t27u))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cAa12)))
    ]
};
const $403c9cfb5b020557$export$2063a590c0694ba8 = (extensions)=>{
    if (!extensions || !Array.isArray(extensions)) return null;
    const mediaType = extensions.find(({ key: key })=>key === 'mediaType');
    return mediaType ? mediaType.value : null;
};
class $403c9cfb5b020557$export$edc04f92718bbea4 extends (0, $cozmU.PureComponent) {
    render() {
        const { mediaType: mediaType, label: label, size: size } = this.props;
        const iconArray = this.getIconArray();
        const sizeIndex = $403c9cfb5b020557$export$c647cb0ee6e282fe.indexOf(size ?? 'medium') || 0;
        const icon = iconArray[sizeIndex];
        const testId = `attachment-icon-${mediaType?.replace('/', '-') ?? 'unknown'}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(icon, {
            size: // @ts-expect-error FIXME: `size` is not an acceptable prop here
            size,
            label: label,
            testId: testId
        });
    }
    constructor(...args){
        super(...args);
        this.getIconArray = ()=>{
            const { mediaType: mediaType, title: title } = this.props;
            if (mediaType && $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType]) return $403c9cfb5b020557$export$724dbd38c6f8ef0[mediaType];
            if (title) {
                const extension = $403c9cfb5b020557$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
                    const matches = extensionMatcher.regexp.exec(title);
                    return !!matches && matches.length > 0;
                });
                if (extension) return extension.icon;
            }
            return $403c9cfb5b020557$export$724dbd38c6f8ef0['default'];
        };
    }
}
module.exports["AttachmentIcon"] = $403c9cfb5b020557$export$edc04f92718bbea4;

});

parcelRegister("4vaoM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a85e440150ad6165$export$761f49b4caa7a581 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JXn3W",
    name: "EditLabelDialogLoader",
    loader: async ()=>(await (parcelRequire("lYWGm"))).EditLabelDialogComponent
});
module.exports["EditLabelDialogLoader"] = $a85e440150ad6165$export$761f49b4caa7a581;

});

parcelRegister("lYWGm", function(module, exports) {

let $04213cc8cd13549d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $04213cc8cd13549d$var$load("6wr18"),
    $04213cc8cd13549d$var$load("7EorR"),
    $04213cc8cd13549d$var$load("4fYzp"),
    $04213cc8cd13549d$var$load("ffEVr"),
    $04213cc8cd13549d$var$load("jigcs"),
    $04213cc8cd13549d$var$load("1fnbu")
]).then(()=>parcelRequire('m0wkE'));

});

parcelRegister("eATLT", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");


var $1NBp8 = parcelRequire("1NBp8");

const $dc31057420aa5644$export$6aee0ce422e62102 = (labelName, spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.LABELLED_CONTENT).toUrl({
        spaceKey: spaceKey,
        labelName: encodeURIComponent(labelName)
    });
    return `${0, $jlIaF.CONTEXT_PATH}/label/${encodeURIComponent(labelName)}`;
};
module.exports["buildLabelUrl"] = $dc31057420aa5644$export$6aee0ce422e62102;

});

parcelRegister("jJK3p", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $dD7ks = parcelRequire("dD7ks");


var $a6t12 = parcelRequire("a6t12");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $buxP3.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $kSwu1.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $kSwu1.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== style || $[13] !== teamsAppPersonProfileUrl || $[14] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: teamsAppPersonProfileUrl,
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = style;
        $[13] = teamsAppPersonProfileUrl;
        $[14] = userId;
        $[15] = t7;
    } else t7 = $[15];
    const renderNameComponent = t7;
    let t8;
    if ($[16] !== fullName || $[17] !== hasViewUserProfilePermission || $[18] !== isAnonymous || $[19] !== renderNameComponent || $[20] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, fullName)));
        $[16] = fullName;
        $[17] = hasViewUserProfilePermission;
        $[18] = isAnonymous;
        $[19] = renderNameComponent;
        $[20] = userId;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $8lYIw = parcelRequire("8lYIw");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    let t0;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== to || $[8] !== url) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: url,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = to;
        $[8] = url;
        $[9] = t0;
    } else t0 = $[9];
    return t0;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("2NFTR", function(module, exports) {

let $20a0a8d2e8da2be2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20a0a8d2e8da2be2$var$load("78ESn").then(()=>parcelRequire('jC6cD'));

});

parcelRegister("3ouCR", function(module, exports) {

let $278b5ea6d475d092$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $278b5ea6d475d092$var$load("9TOep"),
    $278b5ea6d475d092$var$load("6sDJC")
]).then(()=>parcelRequire('2Qk1i'));

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$1764bc361f317144 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dQS92",
    name: "AttachmentActionForgeApp",
    loader: async ()=>(await (parcelRequire("2TrRt"))).AttachmentActionForgeApp
});

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("80yRI"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("gJxFj"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("e10DP"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("8yZcg"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("aPKkp"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("g9YSA"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("7GM0e"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("euNlk"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("3TrhW"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("9Wb2o"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("a2Alk"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("jyhz5"))).PageBannerForgeApp
});
module.exports["AttachmentActionForgeApp"] = $02976f123c8f8e25$export$1764bc361f317144;
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("2TrRt", function(module, exports) {

let $21b6548dff513fef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $21b6548dff513fef$var$load("hUbK8"),
    $21b6548dff513fef$var$load("LWh5V"),
    $21b6548dff513fef$var$load("eRlPy"),
    $21b6548dff513fef$var$load("3eyRH"),
    $21b6548dff513fef$var$load("3Whaz"),
    $21b6548dff513fef$var$load("b6eef"),
    $21b6548dff513fef$var$load("1Gr4q"),
    $21b6548dff513fef$var$load("cuHGj"),
    $21b6548dff513fef$var$load("c3hZB"),
    $21b6548dff513fef$var$load("9cVML"),
    $21b6548dff513fef$var$load("7G12e"),
    $21b6548dff513fef$var$load("4938u"),
    $21b6548dff513fef$var$load("15jTz"),
    $21b6548dff513fef$var$load("48F3z"),
    $21b6548dff513fef$var$load("7SteV"),
    $21b6548dff513fef$var$load("9LJFK"),
    $21b6548dff513fef$var$load("d66hN"),
    $21b6548dff513fef$var$load("dxA9F"),
    $21b6548dff513fef$var$load("bkMxV"),
    $21b6548dff513fef$var$load("exhLE"),
    $21b6548dff513fef$var$load("kQDGR"),
    $21b6548dff513fef$var$load("iZR3N"),
    $21b6548dff513fef$var$load("jXM1T"),
    $21b6548dff513fef$var$load("cvcNg"),
    $21b6548dff513fef$var$load("4N1MY"),
    $21b6548dff513fef$var$load("5MQ0D"),
    $21b6548dff513fef$var$load("i7NGK"),
    $21b6548dff513fef$var$load("cIoRg"),
    $21b6548dff513fef$var$load("g7vSH"),
    $21b6548dff513fef$var$load("jL1Ke"),
    $21b6548dff513fef$var$load("fuOfV"),
    $21b6548dff513fef$var$load("kHXvF"),
    $21b6548dff513fef$var$load("ea3NB"),
    $21b6548dff513fef$var$load("6wr18"),
    $21b6548dff513fef$var$load("ffEVr"),
    $21b6548dff513fef$var$load("59hV4"),
    $21b6548dff513fef$var$load("l4j2l"),
    $21b6548dff513fef$var$load("37v60"),
    $21b6548dff513fef$var$load("cGkFm"),
    $21b6548dff513fef$var$load("eF92L"),
    $21b6548dff513fef$var$load("jwMHX"),
    $21b6548dff513fef$var$load("20wSi"),
    $21b6548dff513fef$var$load("bmOOW"),
    $21b6548dff513fef$var$load("dDiWc"),
    $21b6548dff513fef$var$load("d0ZRF"),
    $21b6548dff513fef$var$load("k507P"),
    $21b6548dff513fef$var$load("fwbNS"),
    $21b6548dff513fef$var$load("gaUhx"),
    $21b6548dff513fef$var$load("h4Nf7"),
    $21b6548dff513fef$var$load("9TOep"),
    $21b6548dff513fef$var$load("bncmK"),
    $21b6548dff513fef$var$load("6iTkp"),
    $21b6548dff513fef$var$load("hhss7"),
    $21b6548dff513fef$var$load("a8R25"),
    $21b6548dff513fef$var$load("lnKog"),
    $21b6548dff513fef$var$load("aAWLw"),
    $21b6548dff513fef$var$load("7EorR"),
    $21b6548dff513fef$var$load("fJ8Kj")
]).then(()=>parcelRequire('2L9yO'));

});

parcelRegister("80yRI", function(module, exports) {

let $5d495e563aa3493f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5d495e563aa3493f$var$load("hUbK8"),
    $5d495e563aa3493f$var$load("LWh5V"),
    $5d495e563aa3493f$var$load("eRlPy"),
    $5d495e563aa3493f$var$load("3eyRH"),
    $5d495e563aa3493f$var$load("3Whaz"),
    $5d495e563aa3493f$var$load("b6eef"),
    $5d495e563aa3493f$var$load("1Gr4q"),
    $5d495e563aa3493f$var$load("cuHGj"),
    $5d495e563aa3493f$var$load("c3hZB"),
    $5d495e563aa3493f$var$load("9cVML"),
    $5d495e563aa3493f$var$load("7G12e"),
    $5d495e563aa3493f$var$load("4938u"),
    $5d495e563aa3493f$var$load("15jTz"),
    $5d495e563aa3493f$var$load("48F3z"),
    $5d495e563aa3493f$var$load("7SteV"),
    $5d495e563aa3493f$var$load("9LJFK"),
    $5d495e563aa3493f$var$load("d66hN"),
    $5d495e563aa3493f$var$load("dxA9F"),
    $5d495e563aa3493f$var$load("bkMxV"),
    $5d495e563aa3493f$var$load("exhLE"),
    $5d495e563aa3493f$var$load("kQDGR"),
    $5d495e563aa3493f$var$load("iZR3N"),
    $5d495e563aa3493f$var$load("jXM1T"),
    $5d495e563aa3493f$var$load("cvcNg"),
    $5d495e563aa3493f$var$load("4N1MY"),
    $5d495e563aa3493f$var$load("5MQ0D"),
    $5d495e563aa3493f$var$load("i7NGK"),
    $5d495e563aa3493f$var$load("cIoRg"),
    $5d495e563aa3493f$var$load("g7vSH"),
    $5d495e563aa3493f$var$load("jL1Ke"),
    $5d495e563aa3493f$var$load("fuOfV"),
    $5d495e563aa3493f$var$load("kHXvF"),
    $5d495e563aa3493f$var$load("ea3NB"),
    $5d495e563aa3493f$var$load("6wr18"),
    $5d495e563aa3493f$var$load("ffEVr"),
    $5d495e563aa3493f$var$load("59hV4"),
    $5d495e563aa3493f$var$load("l4j2l"),
    $5d495e563aa3493f$var$load("37v60"),
    $5d495e563aa3493f$var$load("cGkFm"),
    $5d495e563aa3493f$var$load("eF92L"),
    $5d495e563aa3493f$var$load("jwMHX"),
    $5d495e563aa3493f$var$load("20wSi"),
    $5d495e563aa3493f$var$load("bmOOW"),
    $5d495e563aa3493f$var$load("dDiWc"),
    $5d495e563aa3493f$var$load("d0ZRF"),
    $5d495e563aa3493f$var$load("k507P"),
    $5d495e563aa3493f$var$load("fwbNS"),
    $5d495e563aa3493f$var$load("gaUhx"),
    $5d495e563aa3493f$var$load("h4Nf7"),
    $5d495e563aa3493f$var$load("9TOep"),
    $5d495e563aa3493f$var$load("bncmK"),
    $5d495e563aa3493f$var$load("6iTkp"),
    $5d495e563aa3493f$var$load("hhss7"),
    $5d495e563aa3493f$var$load("a8R25"),
    $5d495e563aa3493f$var$load("lnKog"),
    $5d495e563aa3493f$var$load("aAWLw"),
    $5d495e563aa3493f$var$load("7EorR"),
    $5d495e563aa3493f$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("gJxFj", function(module, exports) {

let $c2eaf68f76d065f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c2eaf68f76d065f4$var$load("hUbK8"),
    $c2eaf68f76d065f4$var$load("LWh5V"),
    $c2eaf68f76d065f4$var$load("eRlPy"),
    $c2eaf68f76d065f4$var$load("3eyRH"),
    $c2eaf68f76d065f4$var$load("3Whaz"),
    $c2eaf68f76d065f4$var$load("b6eef"),
    $c2eaf68f76d065f4$var$load("1Gr4q"),
    $c2eaf68f76d065f4$var$load("cuHGj"),
    $c2eaf68f76d065f4$var$load("c3hZB"),
    $c2eaf68f76d065f4$var$load("9cVML"),
    $c2eaf68f76d065f4$var$load("7G12e"),
    $c2eaf68f76d065f4$var$load("4938u"),
    $c2eaf68f76d065f4$var$load("15jTz"),
    $c2eaf68f76d065f4$var$load("48F3z"),
    $c2eaf68f76d065f4$var$load("7SteV"),
    $c2eaf68f76d065f4$var$load("9LJFK"),
    $c2eaf68f76d065f4$var$load("d66hN"),
    $c2eaf68f76d065f4$var$load("dxA9F"),
    $c2eaf68f76d065f4$var$load("bkMxV"),
    $c2eaf68f76d065f4$var$load("exhLE"),
    $c2eaf68f76d065f4$var$load("kQDGR"),
    $c2eaf68f76d065f4$var$load("iZR3N"),
    $c2eaf68f76d065f4$var$load("jXM1T"),
    $c2eaf68f76d065f4$var$load("cvcNg"),
    $c2eaf68f76d065f4$var$load("4N1MY"),
    $c2eaf68f76d065f4$var$load("5MQ0D"),
    $c2eaf68f76d065f4$var$load("i7NGK"),
    $c2eaf68f76d065f4$var$load("cIoRg"),
    $c2eaf68f76d065f4$var$load("g7vSH"),
    $c2eaf68f76d065f4$var$load("jL1Ke"),
    $c2eaf68f76d065f4$var$load("fuOfV"),
    $c2eaf68f76d065f4$var$load("kHXvF"),
    $c2eaf68f76d065f4$var$load("ea3NB"),
    $c2eaf68f76d065f4$var$load("6wr18"),
    $c2eaf68f76d065f4$var$load("ffEVr"),
    $c2eaf68f76d065f4$var$load("59hV4"),
    $c2eaf68f76d065f4$var$load("l4j2l"),
    $c2eaf68f76d065f4$var$load("37v60"),
    $c2eaf68f76d065f4$var$load("cGkFm"),
    $c2eaf68f76d065f4$var$load("eF92L"),
    $c2eaf68f76d065f4$var$load("jwMHX"),
    $c2eaf68f76d065f4$var$load("20wSi"),
    $c2eaf68f76d065f4$var$load("bmOOW"),
    $c2eaf68f76d065f4$var$load("dDiWc"),
    $c2eaf68f76d065f4$var$load("d0ZRF"),
    $c2eaf68f76d065f4$var$load("k507P"),
    $c2eaf68f76d065f4$var$load("fwbNS"),
    $c2eaf68f76d065f4$var$load("gaUhx"),
    $c2eaf68f76d065f4$var$load("h4Nf7"),
    $c2eaf68f76d065f4$var$load("9TOep"),
    $c2eaf68f76d065f4$var$load("bncmK"),
    $c2eaf68f76d065f4$var$load("6iTkp"),
    $c2eaf68f76d065f4$var$load("hhss7"),
    $c2eaf68f76d065f4$var$load("a8R25"),
    $c2eaf68f76d065f4$var$load("lnKog"),
    $c2eaf68f76d065f4$var$load("aAWLw"),
    $c2eaf68f76d065f4$var$load("7EorR"),
    $c2eaf68f76d065f4$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("e10DP", function(module, exports) {

let $a341a8131311f83f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a341a8131311f83f$var$load("hUbK8"),
    $a341a8131311f83f$var$load("LWh5V"),
    $a341a8131311f83f$var$load("eRlPy"),
    $a341a8131311f83f$var$load("3eyRH"),
    $a341a8131311f83f$var$load("3Whaz"),
    $a341a8131311f83f$var$load("b6eef"),
    $a341a8131311f83f$var$load("1Gr4q"),
    $a341a8131311f83f$var$load("cuHGj"),
    $a341a8131311f83f$var$load("c3hZB"),
    $a341a8131311f83f$var$load("9cVML"),
    $a341a8131311f83f$var$load("7G12e"),
    $a341a8131311f83f$var$load("4938u"),
    $a341a8131311f83f$var$load("15jTz"),
    $a341a8131311f83f$var$load("48F3z"),
    $a341a8131311f83f$var$load("7SteV"),
    $a341a8131311f83f$var$load("9LJFK"),
    $a341a8131311f83f$var$load("d66hN"),
    $a341a8131311f83f$var$load("dxA9F"),
    $a341a8131311f83f$var$load("bkMxV"),
    $a341a8131311f83f$var$load("exhLE"),
    $a341a8131311f83f$var$load("kQDGR"),
    $a341a8131311f83f$var$load("iZR3N"),
    $a341a8131311f83f$var$load("jXM1T"),
    $a341a8131311f83f$var$load("cvcNg"),
    $a341a8131311f83f$var$load("4N1MY"),
    $a341a8131311f83f$var$load("5MQ0D"),
    $a341a8131311f83f$var$load("i7NGK"),
    $a341a8131311f83f$var$load("cIoRg"),
    $a341a8131311f83f$var$load("g7vSH"),
    $a341a8131311f83f$var$load("jL1Ke"),
    $a341a8131311f83f$var$load("fuOfV"),
    $a341a8131311f83f$var$load("kHXvF"),
    $a341a8131311f83f$var$load("ea3NB"),
    $a341a8131311f83f$var$load("6wr18"),
    $a341a8131311f83f$var$load("ffEVr"),
    $a341a8131311f83f$var$load("59hV4"),
    $a341a8131311f83f$var$load("l4j2l"),
    $a341a8131311f83f$var$load("37v60"),
    $a341a8131311f83f$var$load("cGkFm"),
    $a341a8131311f83f$var$load("eF92L"),
    $a341a8131311f83f$var$load("jwMHX"),
    $a341a8131311f83f$var$load("20wSi"),
    $a341a8131311f83f$var$load("bmOOW"),
    $a341a8131311f83f$var$load("dDiWc"),
    $a341a8131311f83f$var$load("d0ZRF"),
    $a341a8131311f83f$var$load("k507P"),
    $a341a8131311f83f$var$load("fwbNS"),
    $a341a8131311f83f$var$load("gaUhx"),
    $a341a8131311f83f$var$load("h4Nf7"),
    $a341a8131311f83f$var$load("9TOep"),
    $a341a8131311f83f$var$load("bncmK"),
    $a341a8131311f83f$var$load("6iTkp"),
    $a341a8131311f83f$var$load("hhss7"),
    $a341a8131311f83f$var$load("a8R25"),
    $a341a8131311f83f$var$load("lnKog"),
    $a341a8131311f83f$var$load("aAWLw"),
    $a341a8131311f83f$var$load("7EorR"),
    $a341a8131311f83f$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("8yZcg", function(module, exports) {

let $63c0f817a5017001$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $63c0f817a5017001$var$load("d0ZRF"),
    $63c0f817a5017001$var$load("k507P"),
    $63c0f817a5017001$var$load("hUbK8"),
    $63c0f817a5017001$var$load("b6eef"),
    $63c0f817a5017001$var$load("1Gr4q"),
    $63c0f817a5017001$var$load("cuHGj"),
    $63c0f817a5017001$var$load("c3hZB"),
    $63c0f817a5017001$var$load("9cVML"),
    $63c0f817a5017001$var$load("7G12e"),
    $63c0f817a5017001$var$load("4938u"),
    $63c0f817a5017001$var$load("7SteV"),
    $63c0f817a5017001$var$load("9LJFK"),
    $63c0f817a5017001$var$load("d66hN"),
    $63c0f817a5017001$var$load("dxA9F"),
    $63c0f817a5017001$var$load("bkMxV"),
    $63c0f817a5017001$var$load("exhLE"),
    $63c0f817a5017001$var$load("kQDGR"),
    $63c0f817a5017001$var$load("iZR3N"),
    $63c0f817a5017001$var$load("jXM1T"),
    $63c0f817a5017001$var$load("cvcNg"),
    $63c0f817a5017001$var$load("6wr18"),
    $63c0f817a5017001$var$load("4N1MY"),
    $63c0f817a5017001$var$load("i7NGK"),
    $63c0f817a5017001$var$load("kHXvF"),
    $63c0f817a5017001$var$load("ea3NB"),
    $63c0f817a5017001$var$load("ffEVr"),
    $63c0f817a5017001$var$load("l4j2l"),
    $63c0f817a5017001$var$load("37v60"),
    $63c0f817a5017001$var$load("cGkFm"),
    $63c0f817a5017001$var$load("eF92L"),
    $63c0f817a5017001$var$load("jwMHX"),
    $63c0f817a5017001$var$load("20wSi"),
    $63c0f817a5017001$var$load("bmOOW"),
    $63c0f817a5017001$var$load("dDiWc"),
    $63c0f817a5017001$var$load("a8R25"),
    $63c0f817a5017001$var$load("gaUhx"),
    $63c0f817a5017001$var$load("h4Nf7"),
    $63c0f817a5017001$var$load("9TOep"),
    $63c0f817a5017001$var$load("bncmK"),
    $63c0f817a5017001$var$load("6iTkp"),
    $63c0f817a5017001$var$load("hhss7"),
    $63c0f817a5017001$var$load("aAWLw"),
    $63c0f817a5017001$var$load("7EorR"),
    $63c0f817a5017001$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("aPKkp", function(module, exports) {

let $7e329a9fd8bb2104$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e329a9fd8bb2104$var$load("d0ZRF"),
    $7e329a9fd8bb2104$var$load("k507P"),
    $7e329a9fd8bb2104$var$load("hUbK8"),
    $7e329a9fd8bb2104$var$load("b6eef"),
    $7e329a9fd8bb2104$var$load("1Gr4q"),
    $7e329a9fd8bb2104$var$load("cuHGj"),
    $7e329a9fd8bb2104$var$load("c3hZB"),
    $7e329a9fd8bb2104$var$load("9cVML"),
    $7e329a9fd8bb2104$var$load("7G12e"),
    $7e329a9fd8bb2104$var$load("4938u"),
    $7e329a9fd8bb2104$var$load("7SteV"),
    $7e329a9fd8bb2104$var$load("9LJFK"),
    $7e329a9fd8bb2104$var$load("d66hN"),
    $7e329a9fd8bb2104$var$load("dxA9F"),
    $7e329a9fd8bb2104$var$load("bkMxV"),
    $7e329a9fd8bb2104$var$load("exhLE"),
    $7e329a9fd8bb2104$var$load("kQDGR"),
    $7e329a9fd8bb2104$var$load("iZR3N"),
    $7e329a9fd8bb2104$var$load("jXM1T"),
    $7e329a9fd8bb2104$var$load("cvcNg"),
    $7e329a9fd8bb2104$var$load("6wr18"),
    $7e329a9fd8bb2104$var$load("4N1MY"),
    $7e329a9fd8bb2104$var$load("i7NGK"),
    $7e329a9fd8bb2104$var$load("kHXvF"),
    $7e329a9fd8bb2104$var$load("ea3NB"),
    $7e329a9fd8bb2104$var$load("ffEVr"),
    $7e329a9fd8bb2104$var$load("l4j2l"),
    $7e329a9fd8bb2104$var$load("37v60"),
    $7e329a9fd8bb2104$var$load("cGkFm"),
    $7e329a9fd8bb2104$var$load("eF92L"),
    $7e329a9fd8bb2104$var$load("jwMHX"),
    $7e329a9fd8bb2104$var$load("20wSi"),
    $7e329a9fd8bb2104$var$load("bmOOW"),
    $7e329a9fd8bb2104$var$load("dDiWc"),
    $7e329a9fd8bb2104$var$load("a8R25"),
    $7e329a9fd8bb2104$var$load("gaUhx"),
    $7e329a9fd8bb2104$var$load("h4Nf7"),
    $7e329a9fd8bb2104$var$load("9TOep"),
    $7e329a9fd8bb2104$var$load("bncmK"),
    $7e329a9fd8bb2104$var$load("6iTkp"),
    $7e329a9fd8bb2104$var$load("hhss7"),
    $7e329a9fd8bb2104$var$load("aAWLw"),
    $7e329a9fd8bb2104$var$load("7EorR"),
    $7e329a9fd8bb2104$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("g9YSA", function(module, exports) {

let $bc3cb5ffacb5d2cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bc3cb5ffacb5d2cf$var$load("d0ZRF"),
    $bc3cb5ffacb5d2cf$var$load("k507P"),
    $bc3cb5ffacb5d2cf$var$load("hUbK8"),
    $bc3cb5ffacb5d2cf$var$load("b6eef"),
    $bc3cb5ffacb5d2cf$var$load("1Gr4q"),
    $bc3cb5ffacb5d2cf$var$load("cuHGj"),
    $bc3cb5ffacb5d2cf$var$load("c3hZB"),
    $bc3cb5ffacb5d2cf$var$load("9cVML"),
    $bc3cb5ffacb5d2cf$var$load("7G12e"),
    $bc3cb5ffacb5d2cf$var$load("4938u"),
    $bc3cb5ffacb5d2cf$var$load("7SteV"),
    $bc3cb5ffacb5d2cf$var$load("9LJFK"),
    $bc3cb5ffacb5d2cf$var$load("d66hN"),
    $bc3cb5ffacb5d2cf$var$load("dxA9F"),
    $bc3cb5ffacb5d2cf$var$load("bkMxV"),
    $bc3cb5ffacb5d2cf$var$load("exhLE"),
    $bc3cb5ffacb5d2cf$var$load("kQDGR"),
    $bc3cb5ffacb5d2cf$var$load("iZR3N"),
    $bc3cb5ffacb5d2cf$var$load("jXM1T"),
    $bc3cb5ffacb5d2cf$var$load("cvcNg"),
    $bc3cb5ffacb5d2cf$var$load("6wr18"),
    $bc3cb5ffacb5d2cf$var$load("4N1MY"),
    $bc3cb5ffacb5d2cf$var$load("i7NGK"),
    $bc3cb5ffacb5d2cf$var$load("kHXvF"),
    $bc3cb5ffacb5d2cf$var$load("ea3NB"),
    $bc3cb5ffacb5d2cf$var$load("ffEVr"),
    $bc3cb5ffacb5d2cf$var$load("l4j2l"),
    $bc3cb5ffacb5d2cf$var$load("37v60"),
    $bc3cb5ffacb5d2cf$var$load("cGkFm"),
    $bc3cb5ffacb5d2cf$var$load("eF92L"),
    $bc3cb5ffacb5d2cf$var$load("jwMHX"),
    $bc3cb5ffacb5d2cf$var$load("20wSi"),
    $bc3cb5ffacb5d2cf$var$load("bmOOW"),
    $bc3cb5ffacb5d2cf$var$load("dDiWc"),
    $bc3cb5ffacb5d2cf$var$load("a8R25"),
    $bc3cb5ffacb5d2cf$var$load("gaUhx"),
    $bc3cb5ffacb5d2cf$var$load("h4Nf7"),
    $bc3cb5ffacb5d2cf$var$load("9TOep"),
    $bc3cb5ffacb5d2cf$var$load("bncmK"),
    $bc3cb5ffacb5d2cf$var$load("6iTkp"),
    $bc3cb5ffacb5d2cf$var$load("hhss7"),
    $bc3cb5ffacb5d2cf$var$load("aAWLw"),
    $bc3cb5ffacb5d2cf$var$load("7EorR"),
    $bc3cb5ffacb5d2cf$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("7GM0e", function(module, exports) {

let $5991b100808184e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5991b100808184e4$var$load("d0ZRF"),
    $5991b100808184e4$var$load("k507P"),
    $5991b100808184e4$var$load("hUbK8"),
    $5991b100808184e4$var$load("b6eef"),
    $5991b100808184e4$var$load("1Gr4q"),
    $5991b100808184e4$var$load("cuHGj"),
    $5991b100808184e4$var$load("c3hZB"),
    $5991b100808184e4$var$load("9cVML"),
    $5991b100808184e4$var$load("7G12e"),
    $5991b100808184e4$var$load("4938u"),
    $5991b100808184e4$var$load("7SteV"),
    $5991b100808184e4$var$load("9LJFK"),
    $5991b100808184e4$var$load("d66hN"),
    $5991b100808184e4$var$load("dxA9F"),
    $5991b100808184e4$var$load("bkMxV"),
    $5991b100808184e4$var$load("exhLE"),
    $5991b100808184e4$var$load("kQDGR"),
    $5991b100808184e4$var$load("iZR3N"),
    $5991b100808184e4$var$load("jXM1T"),
    $5991b100808184e4$var$load("cvcNg"),
    $5991b100808184e4$var$load("6wr18"),
    $5991b100808184e4$var$load("4N1MY"),
    $5991b100808184e4$var$load("i7NGK"),
    $5991b100808184e4$var$load("kHXvF"),
    $5991b100808184e4$var$load("ea3NB"),
    $5991b100808184e4$var$load("ffEVr"),
    $5991b100808184e4$var$load("l4j2l"),
    $5991b100808184e4$var$load("37v60"),
    $5991b100808184e4$var$load("cGkFm"),
    $5991b100808184e4$var$load("eF92L"),
    $5991b100808184e4$var$load("jwMHX"),
    $5991b100808184e4$var$load("20wSi"),
    $5991b100808184e4$var$load("bmOOW"),
    $5991b100808184e4$var$load("dDiWc"),
    $5991b100808184e4$var$load("gaUhx"),
    $5991b100808184e4$var$load("h4Nf7"),
    $5991b100808184e4$var$load("9TOep"),
    $5991b100808184e4$var$load("bncmK"),
    $5991b100808184e4$var$load("6iTkp"),
    $5991b100808184e4$var$load("hhss7"),
    $5991b100808184e4$var$load("a8R25"),
    $5991b100808184e4$var$load("lnKog"),
    $5991b100808184e4$var$load("aAWLw"),
    $5991b100808184e4$var$load("7EorR"),
    $5991b100808184e4$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("euNlk", function(module, exports) {

let $a8da248a9b5cd2c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a8da248a9b5cd2c6$var$load("hUbK8"),
    $a8da248a9b5cd2c6$var$load("3eyRH"),
    $a8da248a9b5cd2c6$var$load("3Whaz"),
    $a8da248a9b5cd2c6$var$load("b6eef"),
    $a8da248a9b5cd2c6$var$load("1Gr4q"),
    $a8da248a9b5cd2c6$var$load("cuHGj"),
    $a8da248a9b5cd2c6$var$load("c3hZB"),
    $a8da248a9b5cd2c6$var$load("9cVML"),
    $a8da248a9b5cd2c6$var$load("7G12e"),
    $a8da248a9b5cd2c6$var$load("4938u"),
    $a8da248a9b5cd2c6$var$load("15jTz"),
    $a8da248a9b5cd2c6$var$load("48F3z"),
    $a8da248a9b5cd2c6$var$load("7SteV"),
    $a8da248a9b5cd2c6$var$load("9LJFK"),
    $a8da248a9b5cd2c6$var$load("d66hN"),
    $a8da248a9b5cd2c6$var$load("dxA9F"),
    $a8da248a9b5cd2c6$var$load("bkMxV"),
    $a8da248a9b5cd2c6$var$load("exhLE"),
    $a8da248a9b5cd2c6$var$load("kQDGR"),
    $a8da248a9b5cd2c6$var$load("iZR3N"),
    $a8da248a9b5cd2c6$var$load("jXM1T"),
    $a8da248a9b5cd2c6$var$load("cvcNg"),
    $a8da248a9b5cd2c6$var$load("4N1MY"),
    $a8da248a9b5cd2c6$var$load("5MQ0D"),
    $a8da248a9b5cd2c6$var$load("i7NGK"),
    $a8da248a9b5cd2c6$var$load("cIoRg"),
    $a8da248a9b5cd2c6$var$load("g7vSH"),
    $a8da248a9b5cd2c6$var$load("jL1Ke"),
    $a8da248a9b5cd2c6$var$load("fuOfV"),
    $a8da248a9b5cd2c6$var$load("kHXvF"),
    $a8da248a9b5cd2c6$var$load("ea3NB"),
    $a8da248a9b5cd2c6$var$load("6wr18"),
    $a8da248a9b5cd2c6$var$load("ffEVr"),
    $a8da248a9b5cd2c6$var$load("59hV4"),
    $a8da248a9b5cd2c6$var$load("l4j2l"),
    $a8da248a9b5cd2c6$var$load("37v60"),
    $a8da248a9b5cd2c6$var$load("cGkFm"),
    $a8da248a9b5cd2c6$var$load("eF92L"),
    $a8da248a9b5cd2c6$var$load("jwMHX"),
    $a8da248a9b5cd2c6$var$load("20wSi"),
    $a8da248a9b5cd2c6$var$load("bmOOW"),
    $a8da248a9b5cd2c6$var$load("dDiWc"),
    $a8da248a9b5cd2c6$var$load("d0ZRF"),
    $a8da248a9b5cd2c6$var$load("k507P"),
    $a8da248a9b5cd2c6$var$load("fwbNS"),
    $a8da248a9b5cd2c6$var$load("gaUhx"),
    $a8da248a9b5cd2c6$var$load("h4Nf7"),
    $a8da248a9b5cd2c6$var$load("9TOep"),
    $a8da248a9b5cd2c6$var$load("bncmK"),
    $a8da248a9b5cd2c6$var$load("6iTkp"),
    $a8da248a9b5cd2c6$var$load("hhss7"),
    $a8da248a9b5cd2c6$var$load("a8R25"),
    $a8da248a9b5cd2c6$var$load("lnKog"),
    $a8da248a9b5cd2c6$var$load("aAWLw"),
    $a8da248a9b5cd2c6$var$load("7EorR"),
    $a8da248a9b5cd2c6$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("3TrhW", function(module, exports) {

let $2d5bad102d3e1a14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2d5bad102d3e1a14$var$load("hUbK8"),
    $2d5bad102d3e1a14$var$load("3eyRH"),
    $2d5bad102d3e1a14$var$load("3Whaz"),
    $2d5bad102d3e1a14$var$load("b6eef"),
    $2d5bad102d3e1a14$var$load("1Gr4q"),
    $2d5bad102d3e1a14$var$load("cuHGj"),
    $2d5bad102d3e1a14$var$load("c3hZB"),
    $2d5bad102d3e1a14$var$load("9cVML"),
    $2d5bad102d3e1a14$var$load("7G12e"),
    $2d5bad102d3e1a14$var$load("4938u"),
    $2d5bad102d3e1a14$var$load("15jTz"),
    $2d5bad102d3e1a14$var$load("48F3z"),
    $2d5bad102d3e1a14$var$load("7SteV"),
    $2d5bad102d3e1a14$var$load("9LJFK"),
    $2d5bad102d3e1a14$var$load("d66hN"),
    $2d5bad102d3e1a14$var$load("dxA9F"),
    $2d5bad102d3e1a14$var$load("bkMxV"),
    $2d5bad102d3e1a14$var$load("exhLE"),
    $2d5bad102d3e1a14$var$load("kQDGR"),
    $2d5bad102d3e1a14$var$load("iZR3N"),
    $2d5bad102d3e1a14$var$load("jXM1T"),
    $2d5bad102d3e1a14$var$load("cvcNg"),
    $2d5bad102d3e1a14$var$load("4N1MY"),
    $2d5bad102d3e1a14$var$load("5MQ0D"),
    $2d5bad102d3e1a14$var$load("i7NGK"),
    $2d5bad102d3e1a14$var$load("cIoRg"),
    $2d5bad102d3e1a14$var$load("g7vSH"),
    $2d5bad102d3e1a14$var$load("jL1Ke"),
    $2d5bad102d3e1a14$var$load("fuOfV"),
    $2d5bad102d3e1a14$var$load("kHXvF"),
    $2d5bad102d3e1a14$var$load("ea3NB"),
    $2d5bad102d3e1a14$var$load("6wr18"),
    $2d5bad102d3e1a14$var$load("ffEVr"),
    $2d5bad102d3e1a14$var$load("59hV4"),
    $2d5bad102d3e1a14$var$load("l4j2l"),
    $2d5bad102d3e1a14$var$load("37v60"),
    $2d5bad102d3e1a14$var$load("cGkFm"),
    $2d5bad102d3e1a14$var$load("eF92L"),
    $2d5bad102d3e1a14$var$load("jwMHX"),
    $2d5bad102d3e1a14$var$load("20wSi"),
    $2d5bad102d3e1a14$var$load("bmOOW"),
    $2d5bad102d3e1a14$var$load("dDiWc"),
    $2d5bad102d3e1a14$var$load("d0ZRF"),
    $2d5bad102d3e1a14$var$load("k507P"),
    $2d5bad102d3e1a14$var$load("fwbNS"),
    $2d5bad102d3e1a14$var$load("gaUhx"),
    $2d5bad102d3e1a14$var$load("h4Nf7"),
    $2d5bad102d3e1a14$var$load("9TOep"),
    $2d5bad102d3e1a14$var$load("bncmK"),
    $2d5bad102d3e1a14$var$load("6iTkp"),
    $2d5bad102d3e1a14$var$load("hhss7"),
    $2d5bad102d3e1a14$var$load("a8R25"),
    $2d5bad102d3e1a14$var$load("lnKog"),
    $2d5bad102d3e1a14$var$load("aAWLw"),
    $2d5bad102d3e1a14$var$load("7EorR"),
    $2d5bad102d3e1a14$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("9Wb2o", function(module, exports) {

let $73c217aedf611782$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73c217aedf611782$var$load("d0ZRF"),
    $73c217aedf611782$var$load("k507P"),
    $73c217aedf611782$var$load("hUbK8"),
    $73c217aedf611782$var$load("b6eef"),
    $73c217aedf611782$var$load("1Gr4q"),
    $73c217aedf611782$var$load("cuHGj"),
    $73c217aedf611782$var$load("c3hZB"),
    $73c217aedf611782$var$load("9cVML"),
    $73c217aedf611782$var$load("7G12e"),
    $73c217aedf611782$var$load("4938u"),
    $73c217aedf611782$var$load("7SteV"),
    $73c217aedf611782$var$load("9LJFK"),
    $73c217aedf611782$var$load("d66hN"),
    $73c217aedf611782$var$load("dxA9F"),
    $73c217aedf611782$var$load("bkMxV"),
    $73c217aedf611782$var$load("exhLE"),
    $73c217aedf611782$var$load("kQDGR"),
    $73c217aedf611782$var$load("iZR3N"),
    $73c217aedf611782$var$load("jXM1T"),
    $73c217aedf611782$var$load("cvcNg"),
    $73c217aedf611782$var$load("6wr18"),
    $73c217aedf611782$var$load("4N1MY"),
    $73c217aedf611782$var$load("i7NGK"),
    $73c217aedf611782$var$load("kHXvF"),
    $73c217aedf611782$var$load("ea3NB"),
    $73c217aedf611782$var$load("ffEVr"),
    $73c217aedf611782$var$load("l4j2l"),
    $73c217aedf611782$var$load("37v60"),
    $73c217aedf611782$var$load("cGkFm"),
    $73c217aedf611782$var$load("eF92L"),
    $73c217aedf611782$var$load("jwMHX"),
    $73c217aedf611782$var$load("20wSi"),
    $73c217aedf611782$var$load("bmOOW"),
    $73c217aedf611782$var$load("dDiWc"),
    $73c217aedf611782$var$load("a8R25"),
    $73c217aedf611782$var$load("gaUhx"),
    $73c217aedf611782$var$load("h4Nf7"),
    $73c217aedf611782$var$load("9TOep"),
    $73c217aedf611782$var$load("bncmK"),
    $73c217aedf611782$var$load("6iTkp"),
    $73c217aedf611782$var$load("hhss7"),
    $73c217aedf611782$var$load("aAWLw"),
    $73c217aedf611782$var$load("7EorR"),
    $73c217aedf611782$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("a2Alk", function(module, exports) {

let $74f64843a956434c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $74f64843a956434c$var$load("d0ZRF"),
    $74f64843a956434c$var$load("k507P"),
    $74f64843a956434c$var$load("hUbK8"),
    $74f64843a956434c$var$load("b6eef"),
    $74f64843a956434c$var$load("1Gr4q"),
    $74f64843a956434c$var$load("cuHGj"),
    $74f64843a956434c$var$load("c3hZB"),
    $74f64843a956434c$var$load("9cVML"),
    $74f64843a956434c$var$load("7G12e"),
    $74f64843a956434c$var$load("4938u"),
    $74f64843a956434c$var$load("7SteV"),
    $74f64843a956434c$var$load("9LJFK"),
    $74f64843a956434c$var$load("d66hN"),
    $74f64843a956434c$var$load("dxA9F"),
    $74f64843a956434c$var$load("bkMxV"),
    $74f64843a956434c$var$load("exhLE"),
    $74f64843a956434c$var$load("kQDGR"),
    $74f64843a956434c$var$load("iZR3N"),
    $74f64843a956434c$var$load("jXM1T"),
    $74f64843a956434c$var$load("cvcNg"),
    $74f64843a956434c$var$load("6wr18"),
    $74f64843a956434c$var$load("4N1MY"),
    $74f64843a956434c$var$load("i7NGK"),
    $74f64843a956434c$var$load("kHXvF"),
    $74f64843a956434c$var$load("ea3NB"),
    $74f64843a956434c$var$load("ffEVr"),
    $74f64843a956434c$var$load("l4j2l"),
    $74f64843a956434c$var$load("37v60"),
    $74f64843a956434c$var$load("cGkFm"),
    $74f64843a956434c$var$load("eF92L"),
    $74f64843a956434c$var$load("jwMHX"),
    $74f64843a956434c$var$load("20wSi"),
    $74f64843a956434c$var$load("bmOOW"),
    $74f64843a956434c$var$load("dDiWc"),
    $74f64843a956434c$var$load("gaUhx"),
    $74f64843a956434c$var$load("h4Nf7"),
    $74f64843a956434c$var$load("9TOep"),
    $74f64843a956434c$var$load("bncmK"),
    $74f64843a956434c$var$load("6iTkp"),
    $74f64843a956434c$var$load("hhss7"),
    $74f64843a956434c$var$load("a8R25"),
    $74f64843a956434c$var$load("lnKog"),
    $74f64843a956434c$var$load("aAWLw"),
    $74f64843a956434c$var$load("7EorR"),
    $74f64843a956434c$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("jyhz5", function(module, exports) {

let $e3bed1528515b966$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e3bed1528515b966$var$load("d0ZRF"),
    $e3bed1528515b966$var$load("k507P"),
    $e3bed1528515b966$var$load("hUbK8"),
    $e3bed1528515b966$var$load("b6eef"),
    $e3bed1528515b966$var$load("1Gr4q"),
    $e3bed1528515b966$var$load("cuHGj"),
    $e3bed1528515b966$var$load("c3hZB"),
    $e3bed1528515b966$var$load("9cVML"),
    $e3bed1528515b966$var$load("7G12e"),
    $e3bed1528515b966$var$load("4938u"),
    $e3bed1528515b966$var$load("7SteV"),
    $e3bed1528515b966$var$load("9LJFK"),
    $e3bed1528515b966$var$load("d66hN"),
    $e3bed1528515b966$var$load("dxA9F"),
    $e3bed1528515b966$var$load("bkMxV"),
    $e3bed1528515b966$var$load("exhLE"),
    $e3bed1528515b966$var$load("kQDGR"),
    $e3bed1528515b966$var$load("iZR3N"),
    $e3bed1528515b966$var$load("jXM1T"),
    $e3bed1528515b966$var$load("cvcNg"),
    $e3bed1528515b966$var$load("6wr18"),
    $e3bed1528515b966$var$load("4N1MY"),
    $e3bed1528515b966$var$load("i7NGK"),
    $e3bed1528515b966$var$load("kHXvF"),
    $e3bed1528515b966$var$load("ea3NB"),
    $e3bed1528515b966$var$load("ffEVr"),
    $e3bed1528515b966$var$load("l4j2l"),
    $e3bed1528515b966$var$load("37v60"),
    $e3bed1528515b966$var$load("cGkFm"),
    $e3bed1528515b966$var$load("eF92L"),
    $e3bed1528515b966$var$load("jwMHX"),
    $e3bed1528515b966$var$load("20wSi"),
    $e3bed1528515b966$var$load("bmOOW"),
    $e3bed1528515b966$var$load("dDiWc"),
    $e3bed1528515b966$var$load("gaUhx"),
    $e3bed1528515b966$var$load("h4Nf7"),
    $e3bed1528515b966$var$load("9TOep"),
    $e3bed1528515b966$var$load("bncmK"),
    $e3bed1528515b966$var$load("6iTkp"),
    $e3bed1528515b966$var$load("hhss7"),
    $e3bed1528515b966$var$load("a8R25"),
    $e3bed1528515b966$var$load("lnKog"),
    $e3bed1528515b966$var$load("aAWLw"),
    $e3bed1528515b966$var$load("7EorR"),
    $e3bed1528515b966$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("kxhju", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iEfsZ = parcelRequire("iEfsZ");


var $cozmU = parcelRequire("cozmU");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $8wW9d = parcelRequire("8wW9d");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $cozmU.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "web-item-location"
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            // Instrument the presence of non-content 3P connect apps so their keys
            // are folded into the page-load `connectAppKeys` telemetry.
            (0, $8wW9d.recordNonContentAppKeys)('web-item', formattedWebItems.map((webItem)=>webItem.completeKey));
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<50efd21e0db5811e6867b792d80a2f0a>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("1wIeS", function(module, exports) {

var $1Rned = parcelRequire("1Rned");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $11cb188fd562c44b$var$uniq(array) {
    return array && array.length ? $1Rned(array) : [];
}
module.exports = $11cb188fd562c44b$var$uniq;

});

parcelRegister("1gjU5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8SfNq = parcelRequire("8SfNq");


var $iRzCQ = parcelRequire("iRzCQ");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _2gHOcPzXzM _1DH08Qjg0e _20DmKqEqul _14Wx5PeKmV _2qRYQF98eZ _0oQUy6YbGa _0tUIKU6wH8 _0WfKEq2Njc _1UNQhUvbI6 _2UvIvUOLYo _1KE8vRbllS _3cgr8TQame _3uAMeFLRg7 _2LESMOvbI6 _0k3IULDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        }, (0, $iRzCQ.handleSuperbatchUnavailable));
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("aJ4wx", function(module, exports) {

let $0203e5a3d28d9f92$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0203e5a3d28d9f92$var$load("bi0bE").then(()=>parcelRequire('l8uTh'));

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("jYZsR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $0b4c17fd4adf87fd$export$de5a461d22cbfa90 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onUpdate: onUpdate, popupRef: popupRef, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onUpdate || $[1] !== popupRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onUpdate, 100);
            const observer = new ResizeObserver(()=>{
                updateWithDelay();
            });
            observer.observe(popupRef);
            return ()=>{
                updateWithDelay.cancel();
                observer.disconnect();
            };
        };
        t2 = [
            popupRef,
            onUpdate
        ];
        $[0] = onUpdate;
        $[1] = popupRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[4] = children;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App resize
        const observer = new ResizeObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef);
        return ()=>{
            updateWithDelay.cancel();
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
};
module.exports["ResizeChangeListener"] = $0b4c17fd4adf87fd$export$de5a461d22cbfa90;

});

parcelRegister("2KM5T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $7Ndnw = parcelRequire("7Ndnw");


var $ahRdE = parcelRequire("ahRdE");

const $27db7b8e788cc94a$var$i18n = (0, $kSwu1.defineMessages)({
    loadingDetails: {
        id: "forge-ui.attachment-action.metadata.loading-details",
        defaultMessage: "Loading attachment details"
    }
});
const $27db7b8e788cc94a$var$styles = {
    loading: "_4c065U8HPE _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1EqgXlN91d"
}; // Use the same viewport while loading the chunk and the Forge resource, so the
const $27db7b8e788cc94a$export$545a330aa6562cd6 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { viewportSize: viewportSize } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== viewportSize) {
        t1 = (0, $ahRdE.calculateSize)((0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION), viewportSize, "metadata");
        $[0] = viewportSize;
        $[1] = t1;
    } else t1 = $[1];
    const { height: height, width: width } = t1;
    let t2;
    if ($[2] !== height || $[3] !== width) {
        t2 = {
            height: height,
            width: width
        };
        $[2] = height;
        $[3] = width;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage($27db7b8e788cc94a$var$i18n.loadingDetails);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            label: t3,
            size: "small"
        });
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t2 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "status",
            style: t2,
            xcss: $27db7b8e788cc94a$var$styles.loading
        }, t4);
        $[9] = t2;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ viewportSize: viewportSize })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { height: height, width: width } = (0, $ahRdE.calculateSize)((0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION), viewportSize, 'metadata');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "status",
        style: {
            height: height,
            width: width
        },
        xcss: $27db7b8e788cc94a$var$styles.loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        label: formatMessage($27db7b8e788cc94a$var$i18n.loadingDetails),
        size: "small"
    }));
};
module.exports["AttachmentActionMetadataLoading"] = $27db7b8e788cc94a$export$545a330aa6562cd6;

});

parcelRegister("ahRdE", function(module, exports) {

var $7Ndnw = parcelRequire("7Ndnw");

const $4ade8642e426074b$var$inlineDialog = {
    small: {
        width: '288px',
        height: '52px'
    },
    medium: {
        width: '288px',
        height: '112px'
    },
    large: {
        width: '400px',
        height: '262px'
    },
    get default () {
        return this.medium;
    }
};
const $4ade8642e426074b$var$homepageFeed = {
    small: {
        width: '100%',
        height: '52px'
    },
    medium: {
        width: '100%',
        height: '112px'
    },
    large: {
        width: '100%',
        height: '262px'
    },
    xlarge: {
        width: '100%',
        height: '524px'
    },
    get default () {
        return this.medium;
    }
};
const $4ade8642e426074b$var$spaceSettings = {
    default: {
        width: '100%',
        height: '65vh'
    }
};
const $4ade8642e426074b$var$globalSettings = {
    default: {
        width: '100%',
        height: '75vh'
    }
};
const $4ade8642e426074b$var$spacePage = {
    default: {
        width: '100%',
        height: '75vh'
    }
};
const $4ade8642e426074b$var$sizes = {
    [(0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION)]: $4ade8642e426074b$var$inlineDialog,
    [(0, $7Ndnw.FORGE_MODULE_BYLINE)]: $4ade8642e426074b$var$inlineDialog,
    [(0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU)]: $4ade8642e426074b$var$inlineDialog,
    [(0, $7Ndnw.FORGE_MODULE_GLOBAL_SETTINGS)]: $4ade8642e426074b$var$globalSettings,
    [(0, $7Ndnw.FORGE_MODULE_HOMEPAGE_FEED)]: $4ade8642e426074b$var$homepageFeed,
    [(0, $7Ndnw.FORGE_MODULE_SPACE_SETTINGS)]: $4ade8642e426074b$var$spaceSettings,
    [(0, $7Ndnw.FORGE_MODULE_SPACE_PAGE)]: $4ade8642e426074b$var$spacePage
};
const $4ade8642e426074b$var$isPositivePixelSize = (value)=>{
    if (typeof value !== 'string' || !/^(?:\d+(?:\.\d+)?|\.\d+)px$/.test(value)) return false;
    const pixels = Number(value.slice(0, -2));
    return Number.isFinite(pixels) && pixels > 0;
};
const $4ade8642e426074b$export$907c7b8171f13ef1 = (type, size, extensionLocation)=>{
    // Custom dimensions apply to attachment metadata popups, not action modals or other modules.
    if (type === (0, $7Ndnw.FORGE_MODULE_ATTACHMENT_ACTION) && extensionLocation === 'metadata' && typeof size === 'object' && size !== null && !Array.isArray(size) && 'width' in size && 'height' in size && $4ade8642e426074b$var$isPositivePixelSize(size.width) && $4ade8642e426074b$var$isPositivePixelSize(size.height)) return {
        width: size.width,
        height: size.height
    };
    const dimensions = $4ade8642e426074b$var$sizes[type];
    if (!dimensions) return {
        height: '100%',
        width: '100%'
    };
    return typeof size === 'string' && Object.prototype.hasOwnProperty.call(dimensions, size) ? dimensions[size] : dimensions.default;
};
module.exports["calculateSize"] = $4ade8642e426074b$export$907c7b8171f13ef1;

});


//# sourceMappingURL=AttachmentsMacroRenderer.a224d93c.js.map
